/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const PromptInitMessage = $root.PromptInitMessage = (() => {

    /**
     * Properties of a PromptInitMessage.
     * @exports IPromptInitMessage
     * @interface IPromptInitMessage
     * @property {number|null} [id] PromptInitMessage id
     * @property {number|null} [index] PromptInitMessage index
     * @property {number|null} [count] PromptInitMessage count
     * @property {Uint8Array|null} [stateVector] PromptInitMessage stateVector
     * @property {UpdateFormatVersion|null} [version] PromptInitMessage version
     * @property {number|null} [ySessionId] the session id of the Yjs document. Will only be sent by server.
     * @property {number|null} [subscriptionId] the subscription id for message sent to a single websocket
     */

    /**
     * Constructs a new PromptInitMessage.
     * @exports PromptInitMessage
     * @classdesc Message sent by the client orserver to prompt the other side to send its
     * init message.
     * 
     * The `stateVector` represents the current state of the document. It's used to ensure the other side
     * can send a minimal update in its `init` message.
     * 
     * Yjs documents and their updates need a common history. Otherwise, Yjs will have bad conflict resolution behaviour
     * (e.g. overwriting content or missing content). The `ySessionId` is an identifier for a Yjs "common history".
     * Peers should only apply updates to a document where the ySessionId matches.
     * ySessionId is managed by the server. The value sent by client peers in promptInit will be ignored.
     * @implements IPromptInitMessage
     * @constructor
     * @param {IPromptInitMessage=} [properties] Properties to set
     */
    function PromptInitMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PromptInitMessage id.
     * @member {number|null|undefined} id
     * @memberof PromptInitMessage
     * @instance
     */
    PromptInitMessage.prototype.id = null;

    /**
     * PromptInitMessage index.
     * @member {number} index
     * @memberof PromptInitMessage
     * @instance
     */
    PromptInitMessage.prototype.index = 0;

    /**
     * PromptInitMessage count.
     * @member {number} count
     * @memberof PromptInitMessage
     * @instance
     */
    PromptInitMessage.prototype.count = 0;

    /**
     * PromptInitMessage stateVector.
     * @member {Uint8Array|null|undefined} stateVector
     * @memberof PromptInitMessage
     * @instance
     */
    PromptInitMessage.prototype.stateVector = null;

    /**
     * PromptInitMessage version.
     * @member {UpdateFormatVersion} version
     * @memberof PromptInitMessage
     * @instance
     */
    PromptInitMessage.prototype.version = 0;

    /**
     * the session id of the Yjs document. Will only be sent by server.
     * @member {number} ySessionId
     * @memberof PromptInitMessage
     * @instance
     */
    PromptInitMessage.prototype.ySessionId = 0;

    /**
     * the subscription id for message sent to a single websocket
     * @member {number|null|undefined} subscriptionId
     * @memberof PromptInitMessage
     * @instance
     */
    PromptInitMessage.prototype.subscriptionId = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(PromptInitMessage.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(PromptInitMessage.prototype, "_stateVector", {
        get: $util.oneOfGetter($oneOfFields = ["stateVector"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(PromptInitMessage.prototype, "_subscriptionId", {
        get: $util.oneOfGetter($oneOfFields = ["subscriptionId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new PromptInitMessage instance using the specified properties.
     * @function create
     * @memberof PromptInitMessage
     * @static
     * @param {IPromptInitMessage=} [properties] Properties to set
     * @returns {PromptInitMessage} PromptInitMessage instance
     */
    PromptInitMessage.create = function create(properties) {
        return new PromptInitMessage(properties);
    };

    /**
     * Encodes the specified PromptInitMessage message. Does not implicitly {@link PromptInitMessage.verify|verify} messages.
     * @function encode
     * @memberof PromptInitMessage
     * @static
     * @param {IPromptInitMessage} message PromptInitMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PromptInitMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        if (message.index != null && Object.hasOwnProperty.call(message, "index"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.index);
        if (message.count != null && Object.hasOwnProperty.call(message, "count"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.count);
        if (message.stateVector != null && Object.hasOwnProperty.call(message, "stateVector"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.stateVector);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.version);
        if (message.ySessionId != null && Object.hasOwnProperty.call(message, "ySessionId"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.ySessionId);
        if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.subscriptionId);
        return writer;
    };

    /**
     * Encodes the specified PromptInitMessage message, length delimited. Does not implicitly {@link PromptInitMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PromptInitMessage
     * @static
     * @param {IPromptInitMessage} message PromptInitMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PromptInitMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a PromptInitMessage message from the specified reader or buffer.
     * @function decode
     * @memberof PromptInitMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PromptInitMessage} PromptInitMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PromptInitMessage.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PromptInitMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    message.index = reader.int32();
                    break;
                }
            case 3: {
                    message.count = reader.int32();
                    break;
                }
            case 4: {
                    message.stateVector = reader.bytes();
                    break;
                }
            case 5: {
                    message.version = reader.int32();
                    break;
                }
            case 6: {
                    message.ySessionId = reader.int32();
                    break;
                }
            case 7: {
                    message.subscriptionId = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PromptInitMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PromptInitMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PromptInitMessage} PromptInitMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PromptInitMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PromptInitMessage message.
     * @function verify
     * @memberof PromptInitMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PromptInitMessage.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            properties._id = 1;
            if (!$util.isInteger(message.id))
                return "id: integer expected";
        }
        if (message.index != null && message.hasOwnProperty("index"))
            if (!$util.isInteger(message.index))
                return "index: integer expected";
        if (message.count != null && message.hasOwnProperty("count"))
            if (!$util.isInteger(message.count))
                return "count: integer expected";
        if (message.stateVector != null && message.hasOwnProperty("stateVector")) {
            properties._stateVector = 1;
            if (!(message.stateVector && typeof message.stateVector.length === "number" || $util.isString(message.stateVector)))
                return "stateVector: buffer expected";
        }
        if (message.version != null && message.hasOwnProperty("version"))
            switch (message.version) {
            default:
                return "version: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.ySessionId != null && message.hasOwnProperty("ySessionId"))
            if (!$util.isInteger(message.ySessionId))
                return "ySessionId: integer expected";
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            properties._subscriptionId = 1;
            if (!$util.isInteger(message.subscriptionId))
                return "subscriptionId: integer expected";
        }
        return null;
    };

    /**
     * Creates a PromptInitMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PromptInitMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PromptInitMessage} PromptInitMessage
     */
    PromptInitMessage.fromObject = function fromObject(object, long) {
        if (object instanceof $root.PromptInitMessage)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.PromptInitMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.index != null)
            message.index = object.index | 0;
        if (object.count != null)
            message.count = object.count | 0;
        if (object.stateVector != null)
            if (typeof object.stateVector === "string")
                $util.base64.decode(object.stateVector, message.stateVector = $util.newBuffer($util.base64.length(object.stateVector)), 0);
            else if (object.stateVector.length >= 0)
                message.stateVector = object.stateVector;
        switch (object.version) {
        default:
            if (typeof object.version === "number") {
                message.version = object.version;
                break;
            }
            break;
        case "UNSPECIFIED":
        case 0:
            message.version = 0;
            break;
        case "V1":
        case 1:
            message.version = 1;
            break;
        case "V2":
        case 2:
            message.version = 2;
            break;
        }
        if (object.ySessionId != null)
            message.ySessionId = object.ySessionId | 0;
        if (object.subscriptionId != null)
            message.subscriptionId = object.subscriptionId | 0;
        return message;
    };

    /**
     * Creates a plain object from a PromptInitMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PromptInitMessage
     * @static
     * @param {PromptInitMessage} message PromptInitMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PromptInitMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.index = 0;
            object.count = 0;
            object.version = options.enums === String ? "UNSPECIFIED" : 0;
            object.ySessionId = 0;
        }
        if (message.id != null && message.hasOwnProperty("id")) {
            object.id = message.id;
            if (options.oneofs)
                object._id = "id";
        }
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        if (message.count != null && message.hasOwnProperty("count"))
            object.count = message.count;
        if (message.stateVector != null && message.hasOwnProperty("stateVector")) {
            object.stateVector = options.bytes === String ? $util.base64.encode(message.stateVector, 0, message.stateVector.length) : options.bytes === Array ? Array.prototype.slice.call(message.stateVector) : message.stateVector;
            if (options.oneofs)
                object._stateVector = "stateVector";
        }
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = options.enums === String ? $root.UpdateFormatVersion[message.version] === undefined ? message.version : $root.UpdateFormatVersion[message.version] : message.version;
        if (message.ySessionId != null && message.hasOwnProperty("ySessionId"))
            object.ySessionId = message.ySessionId;
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            object.subscriptionId = message.subscriptionId;
            if (options.oneofs)
                object._subscriptionId = "subscriptionId";
        }
        return object;
    };

    /**
     * Converts this PromptInitMessage to JSON.
     * @function toJSON
     * @memberof PromptInitMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PromptInitMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PromptInitMessage
     * @function getTypeUrl
     * @memberof PromptInitMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PromptInitMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PromptInitMessage";
    };

    return PromptInitMessage;
})();

export const InitMessage = $root.InitMessage = (() => {

    /**
     * Properties of an InitMessage.
     * @exports IInitMessage
     * @interface IInitMessage
     * @property {number|null} [id] InitMessage id
     * @property {number|null} [index] InitMessage index
     * @property {number|null} [count] InitMessage count
     * @property {Uint8Array|null} [update] InitMessage update
     * @property {UpdateFormatVersion|null} [version] InitMessage version
     * @property {number|null} [ySessionId] the session id of the Yjs document. Will only be sent by server.
     * @property {boolean|null} [readOnly] If true, the client should consider the document read-only.
     * @property {boolean|null} [normalized] If true, the client should trust that all updates on this datasync have been normalized on the server.
     * @property {number|null} [subscriptionId] the subscription id for message sent to a single websocket
     */

    /**
     * Constructs a new InitMessage.
     * @exports InitMessage
     * @classdesc Message sent by the server to the newly connected client.
     * It contains the initial CRDT state update.
     * @implements IInitMessage
     * @constructor
     * @param {IInitMessage=} [properties] Properties to set
     */
    function InitMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * InitMessage id.
     * @member {number|null|undefined} id
     * @memberof InitMessage
     * @instance
     */
    InitMessage.prototype.id = null;

    /**
     * InitMessage index.
     * @member {number} index
     * @memberof InitMessage
     * @instance
     */
    InitMessage.prototype.index = 0;

    /**
     * InitMessage count.
     * @member {number} count
     * @memberof InitMessage
     * @instance
     */
    InitMessage.prototype.count = 0;

    /**
     * InitMessage update.
     * @member {Uint8Array|null|undefined} update
     * @memberof InitMessage
     * @instance
     */
    InitMessage.prototype.update = null;

    /**
     * InitMessage version.
     * @member {UpdateFormatVersion} version
     * @memberof InitMessage
     * @instance
     */
    InitMessage.prototype.version = 0;

    /**
     * the session id of the Yjs document. Will only be sent by server.
     * @member {number} ySessionId
     * @memberof InitMessage
     * @instance
     */
    InitMessage.prototype.ySessionId = 0;

    /**
     * If true, the client should consider the document read-only.
     * @member {boolean} readOnly
     * @memberof InitMessage
     * @instance
     */
    InitMessage.prototype.readOnly = false;

    /**
     * If true, the client should trust that all updates on this datasync have been normalized on the server.
     * @member {boolean} normalized
     * @memberof InitMessage
     * @instance
     */
    InitMessage.prototype.normalized = false;

    /**
     * the subscription id for message sent to a single websocket
     * @member {number|null|undefined} subscriptionId
     * @memberof InitMessage
     * @instance
     */
    InitMessage.prototype.subscriptionId = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(InitMessage.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(InitMessage.prototype, "_update", {
        get: $util.oneOfGetter($oneOfFields = ["update"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(InitMessage.prototype, "_subscriptionId", {
        get: $util.oneOfGetter($oneOfFields = ["subscriptionId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new InitMessage instance using the specified properties.
     * @function create
     * @memberof InitMessage
     * @static
     * @param {IInitMessage=} [properties] Properties to set
     * @returns {InitMessage} InitMessage instance
     */
    InitMessage.create = function create(properties) {
        return new InitMessage(properties);
    };

    /**
     * Encodes the specified InitMessage message. Does not implicitly {@link InitMessage.verify|verify} messages.
     * @function encode
     * @memberof InitMessage
     * @static
     * @param {IInitMessage} message InitMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InitMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        if (message.index != null && Object.hasOwnProperty.call(message, "index"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.index);
        if (message.count != null && Object.hasOwnProperty.call(message, "count"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.count);
        if (message.update != null && Object.hasOwnProperty.call(message, "update"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.update);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.version);
        if (message.ySessionId != null && Object.hasOwnProperty.call(message, "ySessionId"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.ySessionId);
        if (message.readOnly != null && Object.hasOwnProperty.call(message, "readOnly"))
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.readOnly);
        if (message.normalized != null && Object.hasOwnProperty.call(message, "normalized"))
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.normalized);
        if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.subscriptionId);
        return writer;
    };

    /**
     * Encodes the specified InitMessage message, length delimited. Does not implicitly {@link InitMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof InitMessage
     * @static
     * @param {IInitMessage} message InitMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InitMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes an InitMessage message from the specified reader or buffer.
     * @function decode
     * @memberof InitMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {InitMessage} InitMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InitMessage.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.InitMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    message.index = reader.int32();
                    break;
                }
            case 3: {
                    message.count = reader.int32();
                    break;
                }
            case 4: {
                    message.update = reader.bytes();
                    break;
                }
            case 5: {
                    message.version = reader.int32();
                    break;
                }
            case 6: {
                    message.ySessionId = reader.int32();
                    break;
                }
            case 7: {
                    message.readOnly = reader.bool();
                    break;
                }
            case 8: {
                    message.normalized = reader.bool();
                    break;
                }
            case 9: {
                    message.subscriptionId = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an InitMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof InitMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {InitMessage} InitMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InitMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an InitMessage message.
     * @function verify
     * @memberof InitMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    InitMessage.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            properties._id = 1;
            if (!$util.isInteger(message.id))
                return "id: integer expected";
        }
        if (message.index != null && message.hasOwnProperty("index"))
            if (!$util.isInteger(message.index))
                return "index: integer expected";
        if (message.count != null && message.hasOwnProperty("count"))
            if (!$util.isInteger(message.count))
                return "count: integer expected";
        if (message.update != null && message.hasOwnProperty("update")) {
            properties._update = 1;
            if (!(message.update && typeof message.update.length === "number" || $util.isString(message.update)))
                return "update: buffer expected";
        }
        if (message.version != null && message.hasOwnProperty("version"))
            switch (message.version) {
            default:
                return "version: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.ySessionId != null && message.hasOwnProperty("ySessionId"))
            if (!$util.isInteger(message.ySessionId))
                return "ySessionId: integer expected";
        if (message.readOnly != null && message.hasOwnProperty("readOnly"))
            if (typeof message.readOnly !== "boolean")
                return "readOnly: boolean expected";
        if (message.normalized != null && message.hasOwnProperty("normalized"))
            if (typeof message.normalized !== "boolean")
                return "normalized: boolean expected";
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            properties._subscriptionId = 1;
            if (!$util.isInteger(message.subscriptionId))
                return "subscriptionId: integer expected";
        }
        return null;
    };

    /**
     * Creates an InitMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof InitMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {InitMessage} InitMessage
     */
    InitMessage.fromObject = function fromObject(object, long) {
        if (object instanceof $root.InitMessage)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.InitMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.index != null)
            message.index = object.index | 0;
        if (object.count != null)
            message.count = object.count | 0;
        if (object.update != null)
            if (typeof object.update === "string")
                $util.base64.decode(object.update, message.update = $util.newBuffer($util.base64.length(object.update)), 0);
            else if (object.update.length >= 0)
                message.update = object.update;
        switch (object.version) {
        default:
            if (typeof object.version === "number") {
                message.version = object.version;
                break;
            }
            break;
        case "UNSPECIFIED":
        case 0:
            message.version = 0;
            break;
        case "V1":
        case 1:
            message.version = 1;
            break;
        case "V2":
        case 2:
            message.version = 2;
            break;
        }
        if (object.ySessionId != null)
            message.ySessionId = object.ySessionId | 0;
        if (object.readOnly != null)
            message.readOnly = Boolean(object.readOnly);
        if (object.normalized != null)
            message.normalized = Boolean(object.normalized);
        if (object.subscriptionId != null)
            message.subscriptionId = object.subscriptionId | 0;
        return message;
    };

    /**
     * Creates a plain object from an InitMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof InitMessage
     * @static
     * @param {InitMessage} message InitMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    InitMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.index = 0;
            object.count = 0;
            object.version = options.enums === String ? "UNSPECIFIED" : 0;
            object.ySessionId = 0;
            object.readOnly = false;
            object.normalized = false;
        }
        if (message.id != null && message.hasOwnProperty("id")) {
            object.id = message.id;
            if (options.oneofs)
                object._id = "id";
        }
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        if (message.count != null && message.hasOwnProperty("count"))
            object.count = message.count;
        if (message.update != null && message.hasOwnProperty("update")) {
            object.update = options.bytes === String ? $util.base64.encode(message.update, 0, message.update.length) : options.bytes === Array ? Array.prototype.slice.call(message.update) : message.update;
            if (options.oneofs)
                object._update = "update";
        }
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = options.enums === String ? $root.UpdateFormatVersion[message.version] === undefined ? message.version : $root.UpdateFormatVersion[message.version] : message.version;
        if (message.ySessionId != null && message.hasOwnProperty("ySessionId"))
            object.ySessionId = message.ySessionId;
        if (message.readOnly != null && message.hasOwnProperty("readOnly"))
            object.readOnly = message.readOnly;
        if (message.normalized != null && message.hasOwnProperty("normalized"))
            object.normalized = message.normalized;
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            object.subscriptionId = message.subscriptionId;
            if (options.oneofs)
                object._subscriptionId = "subscriptionId";
        }
        return object;
    };

    /**
     * Converts this InitMessage to JSON.
     * @function toJSON
     * @memberof InitMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    InitMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for InitMessage
     * @function getTypeUrl
     * @memberof InitMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    InitMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/InitMessage";
    };

    return InitMessage;
})();

export const UpdateMessage = $root.UpdateMessage = (() => {

    /**
     * Properties of an UpdateMessage.
     * @exports IUpdateMessage
     * @interface IUpdateMessage
     * @property {number|null} [id] UpdateMessage id
     * @property {number|null} [index] UpdateMessage index
     * @property {number|null} [count] UpdateMessage count
     * @property {Uint8Array|null} [update] UpdateMessage update
     * @property {UpdateFormatVersion|null} [version] UpdateMessage version
     * @property {number|null} [ySessionId] the session id of the Yjs document. Sent by both client and server.
     * @property {number|null} [subscriptionId] the subscription id for message sent to a single websocket
     */

    /**
     * Constructs a new UpdateMessage.
     * @exports UpdateMessage
     * @classdesc Message sent between server and client to notify about CRDT state update.
     * @implements IUpdateMessage
     * @constructor
     * @param {IUpdateMessage=} [properties] Properties to set
     */
    function UpdateMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdateMessage id.
     * @member {number|null|undefined} id
     * @memberof UpdateMessage
     * @instance
     */
    UpdateMessage.prototype.id = null;

    /**
     * UpdateMessage index.
     * @member {number} index
     * @memberof UpdateMessage
     * @instance
     */
    UpdateMessage.prototype.index = 0;

    /**
     * UpdateMessage count.
     * @member {number} count
     * @memberof UpdateMessage
     * @instance
     */
    UpdateMessage.prototype.count = 0;

    /**
     * UpdateMessage update.
     * @member {Uint8Array|null|undefined} update
     * @memberof UpdateMessage
     * @instance
     */
    UpdateMessage.prototype.update = null;

    /**
     * UpdateMessage version.
     * @member {UpdateFormatVersion} version
     * @memberof UpdateMessage
     * @instance
     */
    UpdateMessage.prototype.version = 0;

    /**
     * the session id of the Yjs document. Sent by both client and server.
     * @member {number} ySessionId
     * @memberof UpdateMessage
     * @instance
     */
    UpdateMessage.prototype.ySessionId = 0;

    /**
     * the subscription id for message sent to a single websocket
     * @member {number|null|undefined} subscriptionId
     * @memberof UpdateMessage
     * @instance
     */
    UpdateMessage.prototype.subscriptionId = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(UpdateMessage.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(UpdateMessage.prototype, "_update", {
        get: $util.oneOfGetter($oneOfFields = ["update"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(UpdateMessage.prototype, "_subscriptionId", {
        get: $util.oneOfGetter($oneOfFields = ["subscriptionId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new UpdateMessage instance using the specified properties.
     * @function create
     * @memberof UpdateMessage
     * @static
     * @param {IUpdateMessage=} [properties] Properties to set
     * @returns {UpdateMessage} UpdateMessage instance
     */
    UpdateMessage.create = function create(properties) {
        return new UpdateMessage(properties);
    };

    /**
     * Encodes the specified UpdateMessage message. Does not implicitly {@link UpdateMessage.verify|verify} messages.
     * @function encode
     * @memberof UpdateMessage
     * @static
     * @param {IUpdateMessage} message UpdateMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        if (message.index != null && Object.hasOwnProperty.call(message, "index"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.index);
        if (message.count != null && Object.hasOwnProperty.call(message, "count"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.count);
        if (message.update != null && Object.hasOwnProperty.call(message, "update"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.update);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.version);
        if (message.ySessionId != null && Object.hasOwnProperty.call(message, "ySessionId"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.ySessionId);
        if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.subscriptionId);
        return writer;
    };

    /**
     * Encodes the specified UpdateMessage message, length delimited. Does not implicitly {@link UpdateMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdateMessage
     * @static
     * @param {IUpdateMessage} message UpdateMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes an UpdateMessage message from the specified reader or buffer.
     * @function decode
     * @memberof UpdateMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdateMessage} UpdateMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateMessage.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdateMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    message.index = reader.int32();
                    break;
                }
            case 3: {
                    message.count = reader.int32();
                    break;
                }
            case 4: {
                    message.update = reader.bytes();
                    break;
                }
            case 5: {
                    message.version = reader.int32();
                    break;
                }
            case 6: {
                    message.ySessionId = reader.int32();
                    break;
                }
            case 7: {
                    message.subscriptionId = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UpdateMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdateMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdateMessage} UpdateMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdateMessage message.
     * @function verify
     * @memberof UpdateMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdateMessage.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            properties._id = 1;
            if (!$util.isInteger(message.id))
                return "id: integer expected";
        }
        if (message.index != null && message.hasOwnProperty("index"))
            if (!$util.isInteger(message.index))
                return "index: integer expected";
        if (message.count != null && message.hasOwnProperty("count"))
            if (!$util.isInteger(message.count))
                return "count: integer expected";
        if (message.update != null && message.hasOwnProperty("update")) {
            properties._update = 1;
            if (!(message.update && typeof message.update.length === "number" || $util.isString(message.update)))
                return "update: buffer expected";
        }
        if (message.version != null && message.hasOwnProperty("version"))
            switch (message.version) {
            default:
                return "version: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.ySessionId != null && message.hasOwnProperty("ySessionId"))
            if (!$util.isInteger(message.ySessionId))
                return "ySessionId: integer expected";
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            properties._subscriptionId = 1;
            if (!$util.isInteger(message.subscriptionId))
                return "subscriptionId: integer expected";
        }
        return null;
    };

    /**
     * Creates an UpdateMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdateMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdateMessage} UpdateMessage
     */
    UpdateMessage.fromObject = function fromObject(object, long) {
        if (object instanceof $root.UpdateMessage)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.UpdateMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.index != null)
            message.index = object.index | 0;
        if (object.count != null)
            message.count = object.count | 0;
        if (object.update != null)
            if (typeof object.update === "string")
                $util.base64.decode(object.update, message.update = $util.newBuffer($util.base64.length(object.update)), 0);
            else if (object.update.length >= 0)
                message.update = object.update;
        switch (object.version) {
        default:
            if (typeof object.version === "number") {
                message.version = object.version;
                break;
            }
            break;
        case "UNSPECIFIED":
        case 0:
            message.version = 0;
            break;
        case "V1":
        case 1:
            message.version = 1;
            break;
        case "V2":
        case 2:
            message.version = 2;
            break;
        }
        if (object.ySessionId != null)
            message.ySessionId = object.ySessionId | 0;
        if (object.subscriptionId != null)
            message.subscriptionId = object.subscriptionId | 0;
        return message;
    };

    /**
     * Creates a plain object from an UpdateMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdateMessage
     * @static
     * @param {UpdateMessage} message UpdateMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdateMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.index = 0;
            object.count = 0;
            object.version = options.enums === String ? "UNSPECIFIED" : 0;
            object.ySessionId = 0;
        }
        if (message.id != null && message.hasOwnProperty("id")) {
            object.id = message.id;
            if (options.oneofs)
                object._id = "id";
        }
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        if (message.count != null && message.hasOwnProperty("count"))
            object.count = message.count;
        if (message.update != null && message.hasOwnProperty("update")) {
            object.update = options.bytes === String ? $util.base64.encode(message.update, 0, message.update.length) : options.bytes === Array ? Array.prototype.slice.call(message.update) : message.update;
            if (options.oneofs)
                object._update = "update";
        }
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = options.enums === String ? $root.UpdateFormatVersion[message.version] === undefined ? message.version : $root.UpdateFormatVersion[message.version] : message.version;
        if (message.ySessionId != null && message.hasOwnProperty("ySessionId"))
            object.ySessionId = message.ySessionId;
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            object.subscriptionId = message.subscriptionId;
            if (options.oneofs)
                object._subscriptionId = "subscriptionId";
        }
        return object;
    };

    /**
     * Converts this UpdateMessage to JSON.
     * @function toJSON
     * @memberof UpdateMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdateMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdateMessage
     * @function getTypeUrl
     * @memberof UpdateMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdateMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdateMessage";
    };

    return UpdateMessage;
})();

export const StoredUpdate = $root.StoredUpdate = (() => {

    /**
     * Properties of a StoredUpdate.
     * @exports IStoredUpdate
     * @interface IStoredUpdate
     * @property {Uint8Array|null} [update] StoredUpdate update
     * @property {UpdateFormatVersion|null} [version] StoredUpdate version
     */

    /**
     * Constructs a new StoredUpdate.
     * @exports StoredUpdate
     * @classdesc Update stored in a storage on the server.
     * @implements IStoredUpdate
     * @constructor
     * @param {IStoredUpdate=} [properties] Properties to set
     */
    function StoredUpdate(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * StoredUpdate update.
     * @member {Uint8Array|null|undefined} update
     * @memberof StoredUpdate
     * @instance
     */
    StoredUpdate.prototype.update = null;

    /**
     * StoredUpdate version.
     * @member {UpdateFormatVersion|null|undefined} version
     * @memberof StoredUpdate
     * @instance
     */
    StoredUpdate.prototype.version = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(StoredUpdate.prototype, "_update", {
        get: $util.oneOfGetter($oneOfFields = ["update"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(StoredUpdate.prototype, "_version", {
        get: $util.oneOfGetter($oneOfFields = ["version"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new StoredUpdate instance using the specified properties.
     * @function create
     * @memberof StoredUpdate
     * @static
     * @param {IStoredUpdate=} [properties] Properties to set
     * @returns {StoredUpdate} StoredUpdate instance
     */
    StoredUpdate.create = function create(properties) {
        return new StoredUpdate(properties);
    };

    /**
     * Encodes the specified StoredUpdate message. Does not implicitly {@link StoredUpdate.verify|verify} messages.
     * @function encode
     * @memberof StoredUpdate
     * @static
     * @param {IStoredUpdate} message StoredUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StoredUpdate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.update != null && Object.hasOwnProperty.call(message, "update"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.update);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.version);
        return writer;
    };

    /**
     * Encodes the specified StoredUpdate message, length delimited. Does not implicitly {@link StoredUpdate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof StoredUpdate
     * @static
     * @param {IStoredUpdate} message StoredUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StoredUpdate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a StoredUpdate message from the specified reader or buffer.
     * @function decode
     * @memberof StoredUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {StoredUpdate} StoredUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StoredUpdate.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.StoredUpdate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 2: {
                    message.update = reader.bytes();
                    break;
                }
            case 3: {
                    message.version = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a StoredUpdate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof StoredUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {StoredUpdate} StoredUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StoredUpdate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a StoredUpdate message.
     * @function verify
     * @memberof StoredUpdate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    StoredUpdate.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.update != null && message.hasOwnProperty("update")) {
            properties._update = 1;
            if (!(message.update && typeof message.update.length === "number" || $util.isString(message.update)))
                return "update: buffer expected";
        }
        if (message.version != null && message.hasOwnProperty("version")) {
            properties._version = 1;
            switch (message.version) {
            default:
                return "version: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        }
        return null;
    };

    /**
     * Creates a StoredUpdate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof StoredUpdate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {StoredUpdate} StoredUpdate
     */
    StoredUpdate.fromObject = function fromObject(object, long) {
        if (object instanceof $root.StoredUpdate)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.StoredUpdate();
        if (object.update != null)
            if (typeof object.update === "string")
                $util.base64.decode(object.update, message.update = $util.newBuffer($util.base64.length(object.update)), 0);
            else if (object.update.length >= 0)
                message.update = object.update;
        switch (object.version) {
        default:
            if (typeof object.version === "number") {
                message.version = object.version;
                break;
            }
            break;
        case "UNSPECIFIED":
        case 0:
            message.version = 0;
            break;
        case "V1":
        case 1:
            message.version = 1;
            break;
        case "V2":
        case 2:
            message.version = 2;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a StoredUpdate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof StoredUpdate
     * @static
     * @param {StoredUpdate} message StoredUpdate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StoredUpdate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.update != null && message.hasOwnProperty("update")) {
            object.update = options.bytes === String ? $util.base64.encode(message.update, 0, message.update.length) : options.bytes === Array ? Array.prototype.slice.call(message.update) : message.update;
            if (options.oneofs)
                object._update = "update";
        }
        if (message.version != null && message.hasOwnProperty("version")) {
            object.version = options.enums === String ? $root.UpdateFormatVersion[message.version] === undefined ? message.version : $root.UpdateFormatVersion[message.version] : message.version;
            if (options.oneofs)
                object._version = "version";
        }
        return object;
    };

    /**
     * Converts this StoredUpdate to JSON.
     * @function toJSON
     * @memberof StoredUpdate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StoredUpdate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for StoredUpdate
     * @function getTypeUrl
     * @memberof StoredUpdate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    StoredUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/StoredUpdate";
    };

    return StoredUpdate;
})();

export const UpdatePresenceMessage = $root.UpdatePresenceMessage = (() => {

    /**
     * Properties of an UpdatePresenceMessage.
     * @exports IUpdatePresenceMessage
     * @interface IUpdatePresenceMessage
     * @property {number|null} [id] UpdatePresenceMessage id
     * @property {Object.<string,string>|null} [data] UpdatePresenceMessage data
     * @property {Object.<string,Uint8Array>|null} [positions] UpdatePresenceMessage positions
     * @property {number|null} [subscriptionId] the subscription id for message sent to a single websocket
     */

    /**
     * Constructs a new UpdatePresenceMessage.
     * @exports UpdatePresenceMessage
     * @classdesc Message sent by a client to the server to update the user presence.
     * @implements IUpdatePresenceMessage
     * @constructor
     * @param {IUpdatePresenceMessage=} [properties] Properties to set
     */
    function UpdatePresenceMessage(properties) {
        this.data = {};
        this.positions = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdatePresenceMessage id.
     * @member {number|null|undefined} id
     * @memberof UpdatePresenceMessage
     * @instance
     */
    UpdatePresenceMessage.prototype.id = null;

    /**
     * UpdatePresenceMessage data.
     * @member {Object.<string,string>} data
     * @memberof UpdatePresenceMessage
     * @instance
     */
    UpdatePresenceMessage.prototype.data = $util.emptyObject;

    /**
     * UpdatePresenceMessage positions.
     * @member {Object.<string,Uint8Array>} positions
     * @memberof UpdatePresenceMessage
     * @instance
     */
    UpdatePresenceMessage.prototype.positions = $util.emptyObject;

    /**
     * the subscription id for message sent to a single websocket
     * @member {number|null|undefined} subscriptionId
     * @memberof UpdatePresenceMessage
     * @instance
     */
    UpdatePresenceMessage.prototype.subscriptionId = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(UpdatePresenceMessage.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(UpdatePresenceMessage.prototype, "_subscriptionId", {
        get: $util.oneOfGetter($oneOfFields = ["subscriptionId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new UpdatePresenceMessage instance using the specified properties.
     * @function create
     * @memberof UpdatePresenceMessage
     * @static
     * @param {IUpdatePresenceMessage=} [properties] Properties to set
     * @returns {UpdatePresenceMessage} UpdatePresenceMessage instance
     */
    UpdatePresenceMessage.create = function create(properties) {
        return new UpdatePresenceMessage(properties);
    };

    /**
     * Encodes the specified UpdatePresenceMessage message. Does not implicitly {@link UpdatePresenceMessage.verify|verify} messages.
     * @function encode
     * @memberof UpdatePresenceMessage
     * @static
     * @param {IUpdatePresenceMessage} message UpdatePresenceMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdatePresenceMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            for (let keys = Object.keys(message.data), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.data[keys[i]]).ldelim();
        if (message.positions != null && Object.hasOwnProperty.call(message, "positions"))
            for (let keys = Object.keys(message.positions), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).bytes(message.positions[keys[i]]).ldelim();
        if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.subscriptionId);
        return writer;
    };

    /**
     * Encodes the specified UpdatePresenceMessage message, length delimited. Does not implicitly {@link UpdatePresenceMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdatePresenceMessage
     * @static
     * @param {IUpdatePresenceMessage} message UpdatePresenceMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdatePresenceMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes an UpdatePresenceMessage message from the specified reader or buffer.
     * @function decode
     * @memberof UpdatePresenceMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdatePresenceMessage} UpdatePresenceMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdatePresenceMessage.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdatePresenceMessage(), key, value;
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    if (message.data === $util.emptyObject)
                        message.data = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = "";
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.string();
                            break;
                        default:
                            reader.skipType(tag2 & 7, long);
                            break;
                        }
                    }
                    if (key === "__proto__")
                        $util.makeProp(message.data, key);
                    message.data[key] = value;
                    break;
                }
            case 3: {
                    if (message.positions === $util.emptyObject)
                        message.positions = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = [];
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.bytes();
                            break;
                        default:
                            reader.skipType(tag2 & 7, long);
                            break;
                        }
                    }
                    if (key === "__proto__")
                        $util.makeProp(message.positions, key);
                    message.positions[key] = value;
                    break;
                }
            case 4: {
                    message.subscriptionId = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UpdatePresenceMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdatePresenceMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdatePresenceMessage} UpdatePresenceMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdatePresenceMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdatePresenceMessage message.
     * @function verify
     * @memberof UpdatePresenceMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdatePresenceMessage.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            properties._id = 1;
            if (!$util.isInteger(message.id))
                return "id: integer expected";
        }
        if (message.data != null && message.hasOwnProperty("data")) {
            if (!$util.isObject(message.data))
                return "data: object expected";
            let key = Object.keys(message.data);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isString(message.data[key[i]]))
                    return "data: string{k:string} expected";
        }
        if (message.positions != null && message.hasOwnProperty("positions")) {
            if (!$util.isObject(message.positions))
                return "positions: object expected";
            let key = Object.keys(message.positions);
            for (let i = 0; i < key.length; ++i)
                if (!(message.positions[key[i]] && typeof message.positions[key[i]].length === "number" || $util.isString(message.positions[key[i]])))
                    return "positions: buffer{k:string} expected";
        }
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            properties._subscriptionId = 1;
            if (!$util.isInteger(message.subscriptionId))
                return "subscriptionId: integer expected";
        }
        return null;
    };

    /**
     * Creates an UpdatePresenceMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdatePresenceMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdatePresenceMessage} UpdatePresenceMessage
     */
    UpdatePresenceMessage.fromObject = function fromObject(object, long) {
        if (object instanceof $root.UpdatePresenceMessage)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.UpdatePresenceMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.data) {
            if (typeof object.data !== "object")
                throw TypeError(".UpdatePresenceMessage.data: object expected");
            message.data = {};
            for (let keys = Object.keys(object.data), i = 0; i < keys.length; ++i) {
                if (keys[i] === "__proto__")
                    $util.makeProp(message.data, keys[i]);
                message.data[keys[i]] = String(object.data[keys[i]]);
            }
        }
        if (object.positions) {
            if (typeof object.positions !== "object")
                throw TypeError(".UpdatePresenceMessage.positions: object expected");
            message.positions = {};
            for (let keys = Object.keys(object.positions), i = 0; i < keys.length; ++i) {
                if (keys[i] === "__proto__")
                    $util.makeProp(message.positions, keys[i]);
                if (typeof object.positions[keys[i]] === "string")
                    $util.base64.decode(object.positions[keys[i]], message.positions[keys[i]] = $util.newBuffer($util.base64.length(object.positions[keys[i]])), 0);
                else if (object.positions[keys[i]].length >= 0)
                    message.positions[keys[i]] = object.positions[keys[i]];
            }
        }
        if (object.subscriptionId != null)
            message.subscriptionId = object.subscriptionId | 0;
        return message;
    };

    /**
     * Creates a plain object from an UpdatePresenceMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdatePresenceMessage
     * @static
     * @param {UpdatePresenceMessage} message UpdatePresenceMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdatePresenceMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.objects || options.defaults) {
            object.data = {};
            object.positions = {};
        }
        if (message.id != null && message.hasOwnProperty("id")) {
            object.id = message.id;
            if (options.oneofs)
                object._id = "id";
        }
        let keys2;
        if (message.data && (keys2 = Object.keys(message.data)).length) {
            object.data = {};
            for (let j = 0; j < keys2.length; ++j) {
                if (keys2[j] === "__proto__")
                    $util.makeProp(object.data, keys2[j]);
                object.data[keys2[j]] = message.data[keys2[j]];
            }
        }
        if (message.positions && (keys2 = Object.keys(message.positions)).length) {
            object.positions = {};
            for (let j = 0; j < keys2.length; ++j) {
                if (keys2[j] === "__proto__")
                    $util.makeProp(object.positions, keys2[j]);
                object.positions[keys2[j]] = options.bytes === String ? $util.base64.encode(message.positions[keys2[j]], 0, message.positions[keys2[j]].length) : options.bytes === Array ? Array.prototype.slice.call(message.positions[keys2[j]]) : message.positions[keys2[j]];
            }
        }
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            object.subscriptionId = message.subscriptionId;
            if (options.oneofs)
                object._subscriptionId = "subscriptionId";
        }
        return object;
    };

    /**
     * Converts this UpdatePresenceMessage to JSON.
     * @function toJSON
     * @memberof UpdatePresenceMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdatePresenceMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdatePresenceMessage
     * @function getTypeUrl
     * @memberof UpdatePresenceMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdatePresenceMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdatePresenceMessage";
    };

    return UpdatePresenceMessage;
})();

export const AckMessage = $root.AckMessage = (() => {

    /**
     * Properties of an AckMessage.
     * @exports IAckMessage
     * @interface IAckMessage
     * @property {number|null} [id] AckMessage id
     * @property {number|null} [message] AckMessage message
     * @property {number|null} [subscriptionId] the subscription id for message sent to a single websocket
     */

    /**
     * Constructs a new AckMessage.
     * @exports AckMessage
     * @classdesc Message sent by the server to acknowledge the reception of a message.
     * @implements IAckMessage
     * @constructor
     * @param {IAckMessage=} [properties] Properties to set
     */
    function AckMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AckMessage id.
     * @member {number|null|undefined} id
     * @memberof AckMessage
     * @instance
     */
    AckMessage.prototype.id = null;

    /**
     * AckMessage message.
     * @member {number|null|undefined} message
     * @memberof AckMessage
     * @instance
     */
    AckMessage.prototype.message = null;

    /**
     * the subscription id for message sent to a single websocket
     * @member {number|null|undefined} subscriptionId
     * @memberof AckMessage
     * @instance
     */
    AckMessage.prototype.subscriptionId = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(AckMessage.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(AckMessage.prototype, "_message", {
        get: $util.oneOfGetter($oneOfFields = ["message"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(AckMessage.prototype, "_subscriptionId", {
        get: $util.oneOfGetter($oneOfFields = ["subscriptionId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new AckMessage instance using the specified properties.
     * @function create
     * @memberof AckMessage
     * @static
     * @param {IAckMessage=} [properties] Properties to set
     * @returns {AckMessage} AckMessage instance
     */
    AckMessage.create = function create(properties) {
        return new AckMessage(properties);
    };

    /**
     * Encodes the specified AckMessage message. Does not implicitly {@link AckMessage.verify|verify} messages.
     * @function encode
     * @memberof AckMessage
     * @static
     * @param {IAckMessage} message AckMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AckMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.message);
        if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.subscriptionId);
        return writer;
    };

    /**
     * Encodes the specified AckMessage message, length delimited. Does not implicitly {@link AckMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AckMessage
     * @static
     * @param {IAckMessage} message AckMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AckMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes an AckMessage message from the specified reader or buffer.
     * @function decode
     * @memberof AckMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AckMessage} AckMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AckMessage.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AckMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    message.message = reader.int32();
                    break;
                }
            case 3: {
                    message.subscriptionId = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AckMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AckMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AckMessage} AckMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AckMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AckMessage message.
     * @function verify
     * @memberof AckMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AckMessage.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            properties._id = 1;
            if (!$util.isInteger(message.id))
                return "id: integer expected";
        }
        if (message.message != null && message.hasOwnProperty("message")) {
            properties._message = 1;
            if (!$util.isInteger(message.message))
                return "message: integer expected";
        }
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            properties._subscriptionId = 1;
            if (!$util.isInteger(message.subscriptionId))
                return "subscriptionId: integer expected";
        }
        return null;
    };

    /**
     * Creates an AckMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AckMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AckMessage} AckMessage
     */
    AckMessage.fromObject = function fromObject(object, long) {
        if (object instanceof $root.AckMessage)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.AckMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.message != null)
            message.message = object.message | 0;
        if (object.subscriptionId != null)
            message.subscriptionId = object.subscriptionId | 0;
        return message;
    };

    /**
     * Creates a plain object from an AckMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AckMessage
     * @static
     * @param {AckMessage} message AckMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AckMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            object.id = message.id;
            if (options.oneofs)
                object._id = "id";
        }
        if (message.message != null && message.hasOwnProperty("message")) {
            object.message = message.message;
            if (options.oneofs)
                object._message = "message";
        }
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            object.subscriptionId = message.subscriptionId;
            if (options.oneofs)
                object._subscriptionId = "subscriptionId";
        }
        return object;
    };

    /**
     * Converts this AckMessage to JSON.
     * @function toJSON
     * @memberof AckMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AckMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AckMessage
     * @function getTypeUrl
     * @memberof AckMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AckMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AckMessage";
    };

    return AckMessage;
})();

export const BroadcastPresencesMessage = $root.BroadcastPresencesMessage = (() => {

    /**
     * Properties of a BroadcastPresencesMessage.
     * @exports IBroadcastPresencesMessage
     * @interface IBroadcastPresencesMessage
     * @property {number|null} [id] BroadcastPresencesMessage id
     * @property {Object.<string,IPresence>|null} [presences] BroadcastPresencesMessage presences
     * @property {string|null} [selfClientId] BroadcastPresencesMessage selfClientId
     * @property {number|null} [subscriptionId] the subscription id for message sent to a single websocket
     */

    /**
     * Constructs a new BroadcastPresencesMessage.
     * @exports BroadcastPresencesMessage
     * @classdesc Message sent by a client to the server to update the user presence.
     * @implements IBroadcastPresencesMessage
     * @constructor
     * @param {IBroadcastPresencesMessage=} [properties] Properties to set
     */
    function BroadcastPresencesMessage(properties) {
        this.presences = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BroadcastPresencesMessage id.
     * @member {number|null|undefined} id
     * @memberof BroadcastPresencesMessage
     * @instance
     */
    BroadcastPresencesMessage.prototype.id = null;

    /**
     * BroadcastPresencesMessage presences.
     * @member {Object.<string,IPresence>} presences
     * @memberof BroadcastPresencesMessage
     * @instance
     */
    BroadcastPresencesMessage.prototype.presences = $util.emptyObject;

    /**
     * BroadcastPresencesMessage selfClientId.
     * @member {string|null|undefined} selfClientId
     * @memberof BroadcastPresencesMessage
     * @instance
     */
    BroadcastPresencesMessage.prototype.selfClientId = null;

    /**
     * the subscription id for message sent to a single websocket
     * @member {number|null|undefined} subscriptionId
     * @memberof BroadcastPresencesMessage
     * @instance
     */
    BroadcastPresencesMessage.prototype.subscriptionId = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(BroadcastPresencesMessage.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(BroadcastPresencesMessage.prototype, "_selfClientId", {
        get: $util.oneOfGetter($oneOfFields = ["selfClientId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(BroadcastPresencesMessage.prototype, "_subscriptionId", {
        get: $util.oneOfGetter($oneOfFields = ["subscriptionId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new BroadcastPresencesMessage instance using the specified properties.
     * @function create
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {IBroadcastPresencesMessage=} [properties] Properties to set
     * @returns {BroadcastPresencesMessage} BroadcastPresencesMessage instance
     */
    BroadcastPresencesMessage.create = function create(properties) {
        return new BroadcastPresencesMessage(properties);
    };

    /**
     * Encodes the specified BroadcastPresencesMessage message. Does not implicitly {@link BroadcastPresencesMessage.verify|verify} messages.
     * @function encode
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {IBroadcastPresencesMessage} message BroadcastPresencesMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BroadcastPresencesMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        if (message.presences != null && Object.hasOwnProperty.call(message, "presences"))
            for (let keys = Object.keys(message.presences), i = 0; i < keys.length; ++i) {
                writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                $root.Presence.encode(message.presences[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
            }
        if (message.selfClientId != null && Object.hasOwnProperty.call(message, "selfClientId"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.selfClientId);
        if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.subscriptionId);
        return writer;
    };

    /**
     * Encodes the specified BroadcastPresencesMessage message, length delimited. Does not implicitly {@link BroadcastPresencesMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {IBroadcastPresencesMessage} message BroadcastPresencesMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BroadcastPresencesMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a BroadcastPresencesMessage message from the specified reader or buffer.
     * @function decode
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BroadcastPresencesMessage} BroadcastPresencesMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BroadcastPresencesMessage.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BroadcastPresencesMessage(), key, value;
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    if (message.presences === $util.emptyObject)
                        message.presences = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = null;
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = $root.Presence.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        default:
                            reader.skipType(tag2 & 7, long);
                            break;
                        }
                    }
                    if (key === "__proto__")
                        $util.makeProp(message.presences, key);
                    message.presences[key] = value;
                    break;
                }
            case 3: {
                    message.selfClientId = reader.string();
                    break;
                }
            case 4: {
                    message.subscriptionId = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BroadcastPresencesMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BroadcastPresencesMessage} BroadcastPresencesMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BroadcastPresencesMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BroadcastPresencesMessage message.
     * @function verify
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BroadcastPresencesMessage.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            properties._id = 1;
            if (!$util.isInteger(message.id))
                return "id: integer expected";
        }
        if (message.presences != null && message.hasOwnProperty("presences")) {
            if (!$util.isObject(message.presences))
                return "presences: object expected";
            let key = Object.keys(message.presences);
            for (let i = 0; i < key.length; ++i) {
                let error = $root.Presence.verify(message.presences[key[i]], long + 1);
                if (error)
                    return "presences." + error;
            }
        }
        if (message.selfClientId != null && message.hasOwnProperty("selfClientId")) {
            properties._selfClientId = 1;
            if (!$util.isString(message.selfClientId))
                return "selfClientId: string expected";
        }
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            properties._subscriptionId = 1;
            if (!$util.isInteger(message.subscriptionId))
                return "subscriptionId: integer expected";
        }
        return null;
    };

    /**
     * Creates a BroadcastPresencesMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BroadcastPresencesMessage} BroadcastPresencesMessage
     */
    BroadcastPresencesMessage.fromObject = function fromObject(object, long) {
        if (object instanceof $root.BroadcastPresencesMessage)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.BroadcastPresencesMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.presences) {
            if (typeof object.presences !== "object")
                throw TypeError(".BroadcastPresencesMessage.presences: object expected");
            message.presences = {};
            for (let keys = Object.keys(object.presences), i = 0; i < keys.length; ++i) {
                if (keys[i] === "__proto__")
                    $util.makeProp(message.presences, keys[i]);
                if (typeof object.presences[keys[i]] !== "object")
                    throw TypeError(".BroadcastPresencesMessage.presences: object expected");
                message.presences[keys[i]] = $root.Presence.fromObject(object.presences[keys[i]], long + 1);
            }
        }
        if (object.selfClientId != null)
            message.selfClientId = String(object.selfClientId);
        if (object.subscriptionId != null)
            message.subscriptionId = object.subscriptionId | 0;
        return message;
    };

    /**
     * Creates a plain object from a BroadcastPresencesMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {BroadcastPresencesMessage} message BroadcastPresencesMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BroadcastPresencesMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.objects || options.defaults)
            object.presences = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            object.id = message.id;
            if (options.oneofs)
                object._id = "id";
        }
        let keys2;
        if (message.presences && (keys2 = Object.keys(message.presences)).length) {
            object.presences = {};
            for (let j = 0; j < keys2.length; ++j) {
                if (keys2[j] === "__proto__")
                    $util.makeProp(object.presences, keys2[j]);
                object.presences[keys2[j]] = $root.Presence.toObject(message.presences[keys2[j]], options);
            }
        }
        if (message.selfClientId != null && message.hasOwnProperty("selfClientId")) {
            object.selfClientId = message.selfClientId;
            if (options.oneofs)
                object._selfClientId = "selfClientId";
        }
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            object.subscriptionId = message.subscriptionId;
            if (options.oneofs)
                object._subscriptionId = "subscriptionId";
        }
        return object;
    };

    /**
     * Converts this BroadcastPresencesMessage to JSON.
     * @function toJSON
     * @memberof BroadcastPresencesMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BroadcastPresencesMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BroadcastPresencesMessage
     * @function getTypeUrl
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BroadcastPresencesMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BroadcastPresencesMessage";
    };

    return BroadcastPresencesMessage;
})();

export const BroadcastOperationMessage = $root.BroadcastOperationMessage = (() => {

    /**
     * Properties of a BroadcastOperationMessage.
     * @exports IBroadcastOperationMessage
     * @interface IBroadcastOperationMessage
     * @property {number|null} [id] BroadcastOperationMessage id
     * @property {IContentOperation|null} [operation] BroadcastOperationMessage operation
     * @property {number|null} [subscriptionId] the subscription id for message sent to a single websocket
     */

    /**
     * Constructs a new BroadcastOperationMessage.
     * @exports BroadcastOperationMessage
     * @classdesc Message sent by one side with generic data to the other side.
     * @implements IBroadcastOperationMessage
     * @constructor
     * @param {IBroadcastOperationMessage=} [properties] Properties to set
     */
    function BroadcastOperationMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BroadcastOperationMessage id.
     * @member {number|null|undefined} id
     * @memberof BroadcastOperationMessage
     * @instance
     */
    BroadcastOperationMessage.prototype.id = null;

    /**
     * BroadcastOperationMessage operation.
     * @member {IContentOperation|null|undefined} operation
     * @memberof BroadcastOperationMessage
     * @instance
     */
    BroadcastOperationMessage.prototype.operation = null;

    /**
     * the subscription id for message sent to a single websocket
     * @member {number|null|undefined} subscriptionId
     * @memberof BroadcastOperationMessage
     * @instance
     */
    BroadcastOperationMessage.prototype.subscriptionId = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(BroadcastOperationMessage.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(BroadcastOperationMessage.prototype, "_subscriptionId", {
        get: $util.oneOfGetter($oneOfFields = ["subscriptionId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new BroadcastOperationMessage instance using the specified properties.
     * @function create
     * @memberof BroadcastOperationMessage
     * @static
     * @param {IBroadcastOperationMessage=} [properties] Properties to set
     * @returns {BroadcastOperationMessage} BroadcastOperationMessage instance
     */
    BroadcastOperationMessage.create = function create(properties) {
        return new BroadcastOperationMessage(properties);
    };

    /**
     * Encodes the specified BroadcastOperationMessage message. Does not implicitly {@link BroadcastOperationMessage.verify|verify} messages.
     * @function encode
     * @memberof BroadcastOperationMessage
     * @static
     * @param {IBroadcastOperationMessage} message BroadcastOperationMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BroadcastOperationMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
            $root.ContentOperation.encode(message.operation, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.subscriptionId);
        return writer;
    };

    /**
     * Encodes the specified BroadcastOperationMessage message, length delimited. Does not implicitly {@link BroadcastOperationMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BroadcastOperationMessage
     * @static
     * @param {IBroadcastOperationMessage} message BroadcastOperationMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BroadcastOperationMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a BroadcastOperationMessage message from the specified reader or buffer.
     * @function decode
     * @memberof BroadcastOperationMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BroadcastOperationMessage} BroadcastOperationMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BroadcastOperationMessage.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BroadcastOperationMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    message.operation = $root.ContentOperation.decode(reader, reader.uint32(), undefined, long + 1);
                    break;
                }
            case 3: {
                    message.subscriptionId = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BroadcastOperationMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BroadcastOperationMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BroadcastOperationMessage} BroadcastOperationMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BroadcastOperationMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BroadcastOperationMessage message.
     * @function verify
     * @memberof BroadcastOperationMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BroadcastOperationMessage.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            properties._id = 1;
            if (!$util.isInteger(message.id))
                return "id: integer expected";
        }
        if (message.operation != null && message.hasOwnProperty("operation")) {
            let error = $root.ContentOperation.verify(message.operation, long + 1);
            if (error)
                return "operation." + error;
        }
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            properties._subscriptionId = 1;
            if (!$util.isInteger(message.subscriptionId))
                return "subscriptionId: integer expected";
        }
        return null;
    };

    /**
     * Creates a BroadcastOperationMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BroadcastOperationMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BroadcastOperationMessage} BroadcastOperationMessage
     */
    BroadcastOperationMessage.fromObject = function fromObject(object, long) {
        if (object instanceof $root.BroadcastOperationMessage)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.BroadcastOperationMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.operation != null) {
            if (typeof object.operation !== "object")
                throw TypeError(".BroadcastOperationMessage.operation: object expected");
            message.operation = $root.ContentOperation.fromObject(object.operation, long + 1);
        }
        if (object.subscriptionId != null)
            message.subscriptionId = object.subscriptionId | 0;
        return message;
    };

    /**
     * Creates a plain object from a BroadcastOperationMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BroadcastOperationMessage
     * @static
     * @param {BroadcastOperationMessage} message BroadcastOperationMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BroadcastOperationMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.operation = null;
        if (message.id != null && message.hasOwnProperty("id")) {
            object.id = message.id;
            if (options.oneofs)
                object._id = "id";
        }
        if (message.operation != null && message.hasOwnProperty("operation"))
            object.operation = $root.ContentOperation.toObject(message.operation, options);
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            object.subscriptionId = message.subscriptionId;
            if (options.oneofs)
                object._subscriptionId = "subscriptionId";
        }
        return object;
    };

    /**
     * Converts this BroadcastOperationMessage to JSON.
     * @function toJSON
     * @memberof BroadcastOperationMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BroadcastOperationMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BroadcastOperationMessage
     * @function getTypeUrl
     * @memberof BroadcastOperationMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BroadcastOperationMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BroadcastOperationMessage";
    };

    return BroadcastOperationMessage;
})();

export const RPCRequestMessage = $root.RPCRequestMessage = (() => {

    /**
     * Properties of a RPCRequestMessage.
     * @exports IRPCRequestMessage
     * @interface IRPCRequestMessage
     * @property {number|null} [id] RPCRequestMessage id
     * @property {string|null} [service] RPCRequestMessage service
     * @property {string|null} [method] RPCRequestMessage method
     * @property {Uint8Array|null} [payload] RPCRequestMessage payload
     * @property {number|null} [subscriptionId] the subscription id for message sent to a single websocket
     */

    /**
     * Constructs a new RPCRequestMessage.
     * @exports RPCRequestMessage
     * @classdesc Message sent by one side with a generic RPC request to the other side.
     * @implements IRPCRequestMessage
     * @constructor
     * @param {IRPCRequestMessage=} [properties] Properties to set
     */
    function RPCRequestMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RPCRequestMessage id.
     * @member {number|null|undefined} id
     * @memberof RPCRequestMessage
     * @instance
     */
    RPCRequestMessage.prototype.id = null;

    /**
     * RPCRequestMessage service.
     * @member {string|null|undefined} service
     * @memberof RPCRequestMessage
     * @instance
     */
    RPCRequestMessage.prototype.service = null;

    /**
     * RPCRequestMessage method.
     * @member {string|null|undefined} method
     * @memberof RPCRequestMessage
     * @instance
     */
    RPCRequestMessage.prototype.method = null;

    /**
     * RPCRequestMessage payload.
     * @member {Uint8Array|null|undefined} payload
     * @memberof RPCRequestMessage
     * @instance
     */
    RPCRequestMessage.prototype.payload = null;

    /**
     * the subscription id for message sent to a single websocket
     * @member {number|null|undefined} subscriptionId
     * @memberof RPCRequestMessage
     * @instance
     */
    RPCRequestMessage.prototype.subscriptionId = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(RPCRequestMessage.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(RPCRequestMessage.prototype, "_service", {
        get: $util.oneOfGetter($oneOfFields = ["service"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(RPCRequestMessage.prototype, "_method", {
        get: $util.oneOfGetter($oneOfFields = ["method"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(RPCRequestMessage.prototype, "_payload", {
        get: $util.oneOfGetter($oneOfFields = ["payload"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(RPCRequestMessage.prototype, "_subscriptionId", {
        get: $util.oneOfGetter($oneOfFields = ["subscriptionId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new RPCRequestMessage instance using the specified properties.
     * @function create
     * @memberof RPCRequestMessage
     * @static
     * @param {IRPCRequestMessage=} [properties] Properties to set
     * @returns {RPCRequestMessage} RPCRequestMessage instance
     */
    RPCRequestMessage.create = function create(properties) {
        return new RPCRequestMessage(properties);
    };

    /**
     * Encodes the specified RPCRequestMessage message. Does not implicitly {@link RPCRequestMessage.verify|verify} messages.
     * @function encode
     * @memberof RPCRequestMessage
     * @static
     * @param {IRPCRequestMessage} message RPCRequestMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RPCRequestMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        if (message.service != null && Object.hasOwnProperty.call(message, "service"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.service);
        if (message.method != null && Object.hasOwnProperty.call(message, "method"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.method);
        if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.payload);
        if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.subscriptionId);
        return writer;
    };

    /**
     * Encodes the specified RPCRequestMessage message, length delimited. Does not implicitly {@link RPCRequestMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RPCRequestMessage
     * @static
     * @param {IRPCRequestMessage} message RPCRequestMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RPCRequestMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a RPCRequestMessage message from the specified reader or buffer.
     * @function decode
     * @memberof RPCRequestMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RPCRequestMessage} RPCRequestMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RPCRequestMessage.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RPCRequestMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    message.service = reader.string();
                    break;
                }
            case 3: {
                    message.method = reader.string();
                    break;
                }
            case 4: {
                    message.payload = reader.bytes();
                    break;
                }
            case 5: {
                    message.subscriptionId = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RPCRequestMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RPCRequestMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RPCRequestMessage} RPCRequestMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RPCRequestMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RPCRequestMessage message.
     * @function verify
     * @memberof RPCRequestMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RPCRequestMessage.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            properties._id = 1;
            if (!$util.isInteger(message.id))
                return "id: integer expected";
        }
        if (message.service != null && message.hasOwnProperty("service")) {
            properties._service = 1;
            if (!$util.isString(message.service))
                return "service: string expected";
        }
        if (message.method != null && message.hasOwnProperty("method")) {
            properties._method = 1;
            if (!$util.isString(message.method))
                return "method: string expected";
        }
        if (message.payload != null && message.hasOwnProperty("payload")) {
            properties._payload = 1;
            if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
                return "payload: buffer expected";
        }
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            properties._subscriptionId = 1;
            if (!$util.isInteger(message.subscriptionId))
                return "subscriptionId: integer expected";
        }
        return null;
    };

    /**
     * Creates a RPCRequestMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RPCRequestMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RPCRequestMessage} RPCRequestMessage
     */
    RPCRequestMessage.fromObject = function fromObject(object, long) {
        if (object instanceof $root.RPCRequestMessage)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.RPCRequestMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.service != null)
            message.service = String(object.service);
        if (object.method != null)
            message.method = String(object.method);
        if (object.payload != null)
            if (typeof object.payload === "string")
                $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length >= 0)
                message.payload = object.payload;
        if (object.subscriptionId != null)
            message.subscriptionId = object.subscriptionId | 0;
        return message;
    };

    /**
     * Creates a plain object from a RPCRequestMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RPCRequestMessage
     * @static
     * @param {RPCRequestMessage} message RPCRequestMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RPCRequestMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            object.id = message.id;
            if (options.oneofs)
                object._id = "id";
        }
        if (message.service != null && message.hasOwnProperty("service")) {
            object.service = message.service;
            if (options.oneofs)
                object._service = "service";
        }
        if (message.method != null && message.hasOwnProperty("method")) {
            object.method = message.method;
            if (options.oneofs)
                object._method = "method";
        }
        if (message.payload != null && message.hasOwnProperty("payload")) {
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
            if (options.oneofs)
                object._payload = "payload";
        }
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            object.subscriptionId = message.subscriptionId;
            if (options.oneofs)
                object._subscriptionId = "subscriptionId";
        }
        return object;
    };

    /**
     * Converts this RPCRequestMessage to JSON.
     * @function toJSON
     * @memberof RPCRequestMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RPCRequestMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RPCRequestMessage
     * @function getTypeUrl
     * @memberof RPCRequestMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RPCRequestMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RPCRequestMessage";
    };

    return RPCRequestMessage;
})();

export const RPCReplyMessage = $root.RPCReplyMessage = (() => {

    /**
     * Properties of a RPCReplyMessage.
     * @exports IRPCReplyMessage
     * @interface IRPCReplyMessage
     * @property {number|null} [id] RPCReplyMessage id
     * @property {number|null} [replyTo] RPCReplyMessage replyTo
     * @property {Uint8Array|null} [payload] RPCReplyMessage payload
     * @property {IRPCError|null} [error] RPCReplyMessage error
     * @property {number|null} [subscriptionId] the subscription id for message sent to a single websocket
     */

    /**
     * Constructs a new RPCReplyMessage.
     * @exports RPCReplyMessage
     * @classdesc Message sent by one side with a generic RPC reply to the other side.
     * @implements IRPCReplyMessage
     * @constructor
     * @param {IRPCReplyMessage=} [properties] Properties to set
     */
    function RPCReplyMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RPCReplyMessage id.
     * @member {number|null|undefined} id
     * @memberof RPCReplyMessage
     * @instance
     */
    RPCReplyMessage.prototype.id = null;

    /**
     * RPCReplyMessage replyTo.
     * @member {number|null|undefined} replyTo
     * @memberof RPCReplyMessage
     * @instance
     */
    RPCReplyMessage.prototype.replyTo = null;

    /**
     * RPCReplyMessage payload.
     * @member {Uint8Array} payload
     * @memberof RPCReplyMessage
     * @instance
     */
    RPCReplyMessage.prototype.payload = $util.newBuffer([]);

    /**
     * RPCReplyMessage error.
     * @member {IRPCError|null|undefined} error
     * @memberof RPCReplyMessage
     * @instance
     */
    RPCReplyMessage.prototype.error = null;

    /**
     * the subscription id for message sent to a single websocket
     * @member {number|null|undefined} subscriptionId
     * @memberof RPCReplyMessage
     * @instance
     */
    RPCReplyMessage.prototype.subscriptionId = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(RPCReplyMessage.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(RPCReplyMessage.prototype, "_replyTo", {
        get: $util.oneOfGetter($oneOfFields = ["replyTo"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(RPCReplyMessage.prototype, "_subscriptionId", {
        get: $util.oneOfGetter($oneOfFields = ["subscriptionId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new RPCReplyMessage instance using the specified properties.
     * @function create
     * @memberof RPCReplyMessage
     * @static
     * @param {IRPCReplyMessage=} [properties] Properties to set
     * @returns {RPCReplyMessage} RPCReplyMessage instance
     */
    RPCReplyMessage.create = function create(properties) {
        return new RPCReplyMessage(properties);
    };

    /**
     * Encodes the specified RPCReplyMessage message. Does not implicitly {@link RPCReplyMessage.verify|verify} messages.
     * @function encode
     * @memberof RPCReplyMessage
     * @static
     * @param {IRPCReplyMessage} message RPCReplyMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RPCReplyMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        if (message.replyTo != null && Object.hasOwnProperty.call(message, "replyTo"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.replyTo);
        if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.payload);
        if (message.error != null && Object.hasOwnProperty.call(message, "error"))
            $root.RPCError.encode(message.error, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.subscriptionId);
        return writer;
    };

    /**
     * Encodes the specified RPCReplyMessage message, length delimited. Does not implicitly {@link RPCReplyMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RPCReplyMessage
     * @static
     * @param {IRPCReplyMessage} message RPCReplyMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RPCReplyMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a RPCReplyMessage message from the specified reader or buffer.
     * @function decode
     * @memberof RPCReplyMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RPCReplyMessage} RPCReplyMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RPCReplyMessage.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RPCReplyMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    message.replyTo = reader.int32();
                    break;
                }
            case 3: {
                    message.payload = reader.bytes();
                    break;
                }
            case 4: {
                    message.error = $root.RPCError.decode(reader, reader.uint32(), undefined, long + 1);
                    break;
                }
            case 5: {
                    message.subscriptionId = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RPCReplyMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RPCReplyMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RPCReplyMessage} RPCReplyMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RPCReplyMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RPCReplyMessage message.
     * @function verify
     * @memberof RPCReplyMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RPCReplyMessage.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            properties._id = 1;
            if (!$util.isInteger(message.id))
                return "id: integer expected";
        }
        if (message.replyTo != null && message.hasOwnProperty("replyTo")) {
            properties._replyTo = 1;
            if (!$util.isInteger(message.replyTo))
                return "replyTo: integer expected";
        }
        if (message.payload != null && message.hasOwnProperty("payload"))
            if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
                return "payload: buffer expected";
        if (message.error != null && message.hasOwnProperty("error")) {
            let error = $root.RPCError.verify(message.error, long + 1);
            if (error)
                return "error." + error;
        }
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            properties._subscriptionId = 1;
            if (!$util.isInteger(message.subscriptionId))
                return "subscriptionId: integer expected";
        }
        return null;
    };

    /**
     * Creates a RPCReplyMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RPCReplyMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RPCReplyMessage} RPCReplyMessage
     */
    RPCReplyMessage.fromObject = function fromObject(object, long) {
        if (object instanceof $root.RPCReplyMessage)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.RPCReplyMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.replyTo != null)
            message.replyTo = object.replyTo | 0;
        if (object.payload != null)
            if (typeof object.payload === "string")
                $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length >= 0)
                message.payload = object.payload;
        if (object.error != null) {
            if (typeof object.error !== "object")
                throw TypeError(".RPCReplyMessage.error: object expected");
            message.error = $root.RPCError.fromObject(object.error, long + 1);
        }
        if (object.subscriptionId != null)
            message.subscriptionId = object.subscriptionId | 0;
        return message;
    };

    /**
     * Creates a plain object from a RPCReplyMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RPCReplyMessage
     * @static
     * @param {RPCReplyMessage} message RPCReplyMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RPCReplyMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.payload = "";
            else {
                object.payload = [];
                if (options.bytes !== Array)
                    object.payload = $util.newBuffer(object.payload);
            }
            object.error = null;
        }
        if (message.id != null && message.hasOwnProperty("id")) {
            object.id = message.id;
            if (options.oneofs)
                object._id = "id";
        }
        if (message.replyTo != null && message.hasOwnProperty("replyTo")) {
            object.replyTo = message.replyTo;
            if (options.oneofs)
                object._replyTo = "replyTo";
        }
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
        if (message.error != null && message.hasOwnProperty("error"))
            object.error = $root.RPCError.toObject(message.error, options);
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            object.subscriptionId = message.subscriptionId;
            if (options.oneofs)
                object._subscriptionId = "subscriptionId";
        }
        return object;
    };

    /**
     * Converts this RPCReplyMessage to JSON.
     * @function toJSON
     * @memberof RPCReplyMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RPCReplyMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RPCReplyMessage
     * @function getTypeUrl
     * @memberof RPCReplyMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RPCReplyMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RPCReplyMessage";
    };

    return RPCReplyMessage;
})();

export const RPCError = $root.RPCError = (() => {

    /**
     * Properties of a RPCError.
     * @exports IRPCError
     * @interface IRPCError
     * @property {number|null} [code] RPCError code
     * @property {string|null} [message] RPCError message
     */

    /**
     * Constructs a new RPCError.
     * @exports RPCError
     * @classdesc Represents a RPCError.
     * @implements IRPCError
     * @constructor
     * @param {IRPCError=} [properties] Properties to set
     */
    function RPCError(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RPCError code.
     * @member {number|null|undefined} code
     * @memberof RPCError
     * @instance
     */
    RPCError.prototype.code = null;

    /**
     * RPCError message.
     * @member {string|null|undefined} message
     * @memberof RPCError
     * @instance
     */
    RPCError.prototype.message = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(RPCError.prototype, "_code", {
        get: $util.oneOfGetter($oneOfFields = ["code"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(RPCError.prototype, "_message", {
        get: $util.oneOfGetter($oneOfFields = ["message"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new RPCError instance using the specified properties.
     * @function create
     * @memberof RPCError
     * @static
     * @param {IRPCError=} [properties] Properties to set
     * @returns {RPCError} RPCError instance
     */
    RPCError.create = function create(properties) {
        return new RPCError(properties);
    };

    /**
     * Encodes the specified RPCError message. Does not implicitly {@link RPCError.verify|verify} messages.
     * @function encode
     * @memberof RPCError
     * @static
     * @param {IRPCError} message RPCError message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RPCError.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
        return writer;
    };

    /**
     * Encodes the specified RPCError message, length delimited. Does not implicitly {@link RPCError.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RPCError
     * @static
     * @param {IRPCError} message RPCError message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RPCError.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a RPCError message from the specified reader or buffer.
     * @function decode
     * @memberof RPCError
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RPCError} RPCError
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RPCError.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RPCError();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.code = reader.int32();
                    break;
                }
            case 2: {
                    message.message = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RPCError message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RPCError
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RPCError} RPCError
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RPCError.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RPCError message.
     * @function verify
     * @memberof RPCError
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RPCError.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.code != null && message.hasOwnProperty("code")) {
            properties._code = 1;
            if (!$util.isInteger(message.code))
                return "code: integer expected";
        }
        if (message.message != null && message.hasOwnProperty("message")) {
            properties._message = 1;
            if (!$util.isString(message.message))
                return "message: string expected";
        }
        return null;
    };

    /**
     * Creates a RPCError message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RPCError
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RPCError} RPCError
     */
    RPCError.fromObject = function fromObject(object, long) {
        if (object instanceof $root.RPCError)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.RPCError();
        if (object.code != null)
            message.code = object.code | 0;
        if (object.message != null)
            message.message = String(object.message);
        return message;
    };

    /**
     * Creates a plain object from a RPCError message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RPCError
     * @static
     * @param {RPCError} message RPCError
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RPCError.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.code != null && message.hasOwnProperty("code")) {
            object.code = message.code;
            if (options.oneofs)
                object._code = "code";
        }
        if (message.message != null && message.hasOwnProperty("message")) {
            object.message = message.message;
            if (options.oneofs)
                object._message = "message";
        }
        return object;
    };

    /**
     * Converts this RPCError to JSON.
     * @function toJSON
     * @memberof RPCError
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RPCError.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RPCError
     * @function getTypeUrl
     * @memberof RPCError
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RPCError.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RPCError";
    };

    return RPCError;
})();

export const broadcastMarkersMessage = $root.broadcastMarkersMessage = (() => {

    /**
     * Properties of a broadcastMarkersMessage.
     * @exports IbroadcastMarkersMessage
     * @interface IbroadcastMarkersMessage
     * @property {number|null} [id] broadcastMarkersMessage id
     * @property {Array.<IContentMarker>|null} [markers] broadcastMarkersMessage markers
     * @property {number|null} [subscriptionId] the subscription id for message sent to a single websocket
     */

    /**
     * Constructs a new broadcastMarkersMessage.
     * @exports broadcastMarkersMessage
     * @classdesc Message sent by the server with the list of content markers.
     * @implements IbroadcastMarkersMessage
     * @constructor
     * @param {IbroadcastMarkersMessage=} [properties] Properties to set
     */
    function broadcastMarkersMessage(properties) {
        this.markers = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * broadcastMarkersMessage id.
     * @member {number|null|undefined} id
     * @memberof broadcastMarkersMessage
     * @instance
     */
    broadcastMarkersMessage.prototype.id = null;

    /**
     * broadcastMarkersMessage markers.
     * @member {Array.<IContentMarker>} markers
     * @memberof broadcastMarkersMessage
     * @instance
     */
    broadcastMarkersMessage.prototype.markers = $util.emptyArray;

    /**
     * the subscription id for message sent to a single websocket
     * @member {number|null|undefined} subscriptionId
     * @memberof broadcastMarkersMessage
     * @instance
     */
    broadcastMarkersMessage.prototype.subscriptionId = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(broadcastMarkersMessage.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(broadcastMarkersMessage.prototype, "_subscriptionId", {
        get: $util.oneOfGetter($oneOfFields = ["subscriptionId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new broadcastMarkersMessage instance using the specified properties.
     * @function create
     * @memberof broadcastMarkersMessage
     * @static
     * @param {IbroadcastMarkersMessage=} [properties] Properties to set
     * @returns {broadcastMarkersMessage} broadcastMarkersMessage instance
     */
    broadcastMarkersMessage.create = function create(properties) {
        return new broadcastMarkersMessage(properties);
    };

    /**
     * Encodes the specified broadcastMarkersMessage message. Does not implicitly {@link broadcastMarkersMessage.verify|verify} messages.
     * @function encode
     * @memberof broadcastMarkersMessage
     * @static
     * @param {IbroadcastMarkersMessage} message broadcastMarkersMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    broadcastMarkersMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        if (message.markers != null && message.markers.length)
            for (let i = 0; i < message.markers.length; ++i)
                $root.ContentMarker.encode(message.markers[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.subscriptionId);
        return writer;
    };

    /**
     * Encodes the specified broadcastMarkersMessage message, length delimited. Does not implicitly {@link broadcastMarkersMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof broadcastMarkersMessage
     * @static
     * @param {IbroadcastMarkersMessage} message broadcastMarkersMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    broadcastMarkersMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a broadcastMarkersMessage message from the specified reader or buffer.
     * @function decode
     * @memberof broadcastMarkersMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {broadcastMarkersMessage} broadcastMarkersMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    broadcastMarkersMessage.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.broadcastMarkersMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    if (!(message.markers && message.markers.length))
                        message.markers = [];
                    message.markers.push($root.ContentMarker.decode(reader, reader.uint32(), undefined, long + 1));
                    break;
                }
            case 3: {
                    message.subscriptionId = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a broadcastMarkersMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof broadcastMarkersMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {broadcastMarkersMessage} broadcastMarkersMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    broadcastMarkersMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a broadcastMarkersMessage message.
     * @function verify
     * @memberof broadcastMarkersMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    broadcastMarkersMessage.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            properties._id = 1;
            if (!$util.isInteger(message.id))
                return "id: integer expected";
        }
        if (message.markers != null && message.hasOwnProperty("markers")) {
            if (!Array.isArray(message.markers))
                return "markers: array expected";
            for (let i = 0; i < message.markers.length; ++i) {
                let error = $root.ContentMarker.verify(message.markers[i], long + 1);
                if (error)
                    return "markers." + error;
            }
        }
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            properties._subscriptionId = 1;
            if (!$util.isInteger(message.subscriptionId))
                return "subscriptionId: integer expected";
        }
        return null;
    };

    /**
     * Creates a broadcastMarkersMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof broadcastMarkersMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {broadcastMarkersMessage} broadcastMarkersMessage
     */
    broadcastMarkersMessage.fromObject = function fromObject(object, long) {
        if (object instanceof $root.broadcastMarkersMessage)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.broadcastMarkersMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.markers) {
            if (!Array.isArray(object.markers))
                throw TypeError(".broadcastMarkersMessage.markers: array expected");
            message.markers = [];
            for (let i = 0; i < object.markers.length; ++i) {
                if (typeof object.markers[i] !== "object")
                    throw TypeError(".broadcastMarkersMessage.markers: object expected");
                message.markers[i] = $root.ContentMarker.fromObject(object.markers[i], long + 1);
            }
        }
        if (object.subscriptionId != null)
            message.subscriptionId = object.subscriptionId | 0;
        return message;
    };

    /**
     * Creates a plain object from a broadcastMarkersMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof broadcastMarkersMessage
     * @static
     * @param {broadcastMarkersMessage} message broadcastMarkersMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    broadcastMarkersMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.markers = [];
        if (message.id != null && message.hasOwnProperty("id")) {
            object.id = message.id;
            if (options.oneofs)
                object._id = "id";
        }
        if (message.markers && message.markers.length) {
            object.markers = [];
            for (let j = 0; j < message.markers.length; ++j)
                object.markers[j] = $root.ContentMarker.toObject(message.markers[j], options);
        }
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            object.subscriptionId = message.subscriptionId;
            if (options.oneofs)
                object._subscriptionId = "subscriptionId";
        }
        return object;
    };

    /**
     * Converts this broadcastMarkersMessage to JSON.
     * @function toJSON
     * @memberof broadcastMarkersMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    broadcastMarkersMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for broadcastMarkersMessage
     * @function getTypeUrl
     * @memberof broadcastMarkersMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    broadcastMarkersMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/broadcastMarkersMessage";
    };

    return broadcastMarkersMessage;
})();

export const Message = $root.Message = (() => {

    /**
     * Properties of a Message.
     * @exports IMessage
     * @interface IMessage
     * @property {IPromptInitMessage|null} [promptInit] Message promptInit
     * @property {IInitMessage|null} [init] Message init
     * @property {IUpdateMessage|null} [update] Message update
     * @property {IUpdatePresenceMessage|null} [updatePresence] Message updatePresence
     * @property {IBroadcastPresencesMessage|null} [broadcastPresences] Message broadcastPresences
     * @property {IBroadcastOperationMessage|null} [broadcastOperation] Message broadcastOperation
     * @property {IAckMessage|null} [ack] Message ack
     * @property {IRPCRequestMessage|null} [rpcRequest] Message rpcRequest
     * @property {IRPCReplyMessage|null} [rpcReply] Message rpcReply
     * @property {IbroadcastMarkersMessage|null} [broadcastMarkers] Message broadcastMarkers
     */

    /**
     * Constructs a new Message.
     * @exports Message
     * @classdesc Any message that can be sent between the client and the server.
     * @implements IMessage
     * @constructor
     * @param {IMessage=} [properties] Properties to set
     */
    function Message(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Message promptInit.
     * @member {IPromptInitMessage|null|undefined} promptInit
     * @memberof Message
     * @instance
     */
    Message.prototype.promptInit = null;

    /**
     * Message init.
     * @member {IInitMessage|null|undefined} init
     * @memberof Message
     * @instance
     */
    Message.prototype.init = null;

    /**
     * Message update.
     * @member {IUpdateMessage|null|undefined} update
     * @memberof Message
     * @instance
     */
    Message.prototype.update = null;

    /**
     * Message updatePresence.
     * @member {IUpdatePresenceMessage|null|undefined} updatePresence
     * @memberof Message
     * @instance
     */
    Message.prototype.updatePresence = null;

    /**
     * Message broadcastPresences.
     * @member {IBroadcastPresencesMessage|null|undefined} broadcastPresences
     * @memberof Message
     * @instance
     */
    Message.prototype.broadcastPresences = null;

    /**
     * Message broadcastOperation.
     * @member {IBroadcastOperationMessage|null|undefined} broadcastOperation
     * @memberof Message
     * @instance
     */
    Message.prototype.broadcastOperation = null;

    /**
     * Message ack.
     * @member {IAckMessage|null|undefined} ack
     * @memberof Message
     * @instance
     */
    Message.prototype.ack = null;

    /**
     * Message rpcRequest.
     * @member {IRPCRequestMessage|null|undefined} rpcRequest
     * @memberof Message
     * @instance
     */
    Message.prototype.rpcRequest = null;

    /**
     * Message rpcReply.
     * @member {IRPCReplyMessage|null|undefined} rpcReply
     * @memberof Message
     * @instance
     */
    Message.prototype.rpcReply = null;

    /**
     * Message broadcastMarkers.
     * @member {IbroadcastMarkersMessage|null|undefined} broadcastMarkers
     * @memberof Message
     * @instance
     */
    Message.prototype.broadcastMarkers = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * Message message.
     * @member {"promptInit"|"init"|"update"|"updatePresence"|"broadcastPresences"|"broadcastOperation"|"ack"|"rpcRequest"|"rpcReply"|"broadcastMarkers"|undefined} message
     * @memberof Message
     * @instance
     */
    Object.defineProperty(Message.prototype, "message", {
        get: $util.oneOfGetter($oneOfFields = ["promptInit", "init", "update", "updatePresence", "broadcastPresences", "broadcastOperation", "ack", "rpcRequest", "rpcReply", "broadcastMarkers"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Message instance using the specified properties.
     * @function create
     * @memberof Message
     * @static
     * @param {IMessage=} [properties] Properties to set
     * @returns {Message} Message instance
     */
    Message.create = function create(properties) {
        return new Message(properties);
    };

    /**
     * Encodes the specified Message message. Does not implicitly {@link Message.verify|verify} messages.
     * @function encode
     * @memberof Message
     * @static
     * @param {IMessage} message Message message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Message.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.promptInit != null && Object.hasOwnProperty.call(message, "promptInit"))
            $root.PromptInitMessage.encode(message.promptInit, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.init != null && Object.hasOwnProperty.call(message, "init"))
            $root.InitMessage.encode(message.init, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.update != null && Object.hasOwnProperty.call(message, "update"))
            $root.UpdateMessage.encode(message.update, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.updatePresence != null && Object.hasOwnProperty.call(message, "updatePresence"))
            $root.UpdatePresenceMessage.encode(message.updatePresence, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.broadcastPresences != null && Object.hasOwnProperty.call(message, "broadcastPresences"))
            $root.BroadcastPresencesMessage.encode(message.broadcastPresences, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.broadcastOperation != null && Object.hasOwnProperty.call(message, "broadcastOperation"))
            $root.BroadcastOperationMessage.encode(message.broadcastOperation, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.ack != null && Object.hasOwnProperty.call(message, "ack"))
            $root.AckMessage.encode(message.ack, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.rpcRequest != null && Object.hasOwnProperty.call(message, "rpcRequest"))
            $root.RPCRequestMessage.encode(message.rpcRequest, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.rpcReply != null && Object.hasOwnProperty.call(message, "rpcReply"))
            $root.RPCReplyMessage.encode(message.rpcReply, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        if (message.broadcastMarkers != null && Object.hasOwnProperty.call(message, "broadcastMarkers"))
            $root.broadcastMarkersMessage.encode(message.broadcastMarkers, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Message message, length delimited. Does not implicitly {@link Message.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Message
     * @static
     * @param {IMessage} message Message message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Message.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a Message message from the specified reader or buffer.
     * @function decode
     * @memberof Message
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Message} Message
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Message.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Message();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.promptInit = $root.PromptInitMessage.decode(reader, reader.uint32(), undefined, long + 1);
                    break;
                }
            case 2: {
                    message.init = $root.InitMessage.decode(reader, reader.uint32(), undefined, long + 1);
                    break;
                }
            case 3: {
                    message.update = $root.UpdateMessage.decode(reader, reader.uint32(), undefined, long + 1);
                    break;
                }
            case 4: {
                    message.updatePresence = $root.UpdatePresenceMessage.decode(reader, reader.uint32(), undefined, long + 1);
                    break;
                }
            case 5: {
                    message.broadcastPresences = $root.BroadcastPresencesMessage.decode(reader, reader.uint32(), undefined, long + 1);
                    break;
                }
            case 6: {
                    message.broadcastOperation = $root.BroadcastOperationMessage.decode(reader, reader.uint32(), undefined, long + 1);
                    break;
                }
            case 7: {
                    message.ack = $root.AckMessage.decode(reader, reader.uint32(), undefined, long + 1);
                    break;
                }
            case 8: {
                    message.rpcRequest = $root.RPCRequestMessage.decode(reader, reader.uint32(), undefined, long + 1);
                    break;
                }
            case 9: {
                    message.rpcReply = $root.RPCReplyMessage.decode(reader, reader.uint32(), undefined, long + 1);
                    break;
                }
            case 10: {
                    message.broadcastMarkers = $root.broadcastMarkersMessage.decode(reader, reader.uint32(), undefined, long + 1);
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Message message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Message
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Message} Message
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Message.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Message message.
     * @function verify
     * @memberof Message
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Message.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.promptInit != null && message.hasOwnProperty("promptInit")) {
            properties.message = 1;
            {
                let error = $root.PromptInitMessage.verify(message.promptInit, long + 1);
                if (error)
                    return "promptInit." + error;
            }
        }
        if (message.init != null && message.hasOwnProperty("init")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.InitMessage.verify(message.init, long + 1);
                if (error)
                    return "init." + error;
            }
        }
        if (message.update != null && message.hasOwnProperty("update")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.UpdateMessage.verify(message.update, long + 1);
                if (error)
                    return "update." + error;
            }
        }
        if (message.updatePresence != null && message.hasOwnProperty("updatePresence")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.UpdatePresenceMessage.verify(message.updatePresence, long + 1);
                if (error)
                    return "updatePresence." + error;
            }
        }
        if (message.broadcastPresences != null && message.hasOwnProperty("broadcastPresences")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.BroadcastPresencesMessage.verify(message.broadcastPresences, long + 1);
                if (error)
                    return "broadcastPresences." + error;
            }
        }
        if (message.broadcastOperation != null && message.hasOwnProperty("broadcastOperation")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.BroadcastOperationMessage.verify(message.broadcastOperation, long + 1);
                if (error)
                    return "broadcastOperation." + error;
            }
        }
        if (message.ack != null && message.hasOwnProperty("ack")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.AckMessage.verify(message.ack, long + 1);
                if (error)
                    return "ack." + error;
            }
        }
        if (message.rpcRequest != null && message.hasOwnProperty("rpcRequest")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.RPCRequestMessage.verify(message.rpcRequest, long + 1);
                if (error)
                    return "rpcRequest." + error;
            }
        }
        if (message.rpcReply != null && message.hasOwnProperty("rpcReply")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.RPCReplyMessage.verify(message.rpcReply, long + 1);
                if (error)
                    return "rpcReply." + error;
            }
        }
        if (message.broadcastMarkers != null && message.hasOwnProperty("broadcastMarkers")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.broadcastMarkersMessage.verify(message.broadcastMarkers, long + 1);
                if (error)
                    return "broadcastMarkers." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Message message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Message
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Message} Message
     */
    Message.fromObject = function fromObject(object, long) {
        if (object instanceof $root.Message)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.Message();
        if (object.promptInit != null) {
            if (typeof object.promptInit !== "object")
                throw TypeError(".Message.promptInit: object expected");
            message.promptInit = $root.PromptInitMessage.fromObject(object.promptInit, long + 1);
        }
        if (object.init != null) {
            if (typeof object.init !== "object")
                throw TypeError(".Message.init: object expected");
            message.init = $root.InitMessage.fromObject(object.init, long + 1);
        }
        if (object.update != null) {
            if (typeof object.update !== "object")
                throw TypeError(".Message.update: object expected");
            message.update = $root.UpdateMessage.fromObject(object.update, long + 1);
        }
        if (object.updatePresence != null) {
            if (typeof object.updatePresence !== "object")
                throw TypeError(".Message.updatePresence: object expected");
            message.updatePresence = $root.UpdatePresenceMessage.fromObject(object.updatePresence, long + 1);
        }
        if (object.broadcastPresences != null) {
            if (typeof object.broadcastPresences !== "object")
                throw TypeError(".Message.broadcastPresences: object expected");
            message.broadcastPresences = $root.BroadcastPresencesMessage.fromObject(object.broadcastPresences, long + 1);
        }
        if (object.broadcastOperation != null) {
            if (typeof object.broadcastOperation !== "object")
                throw TypeError(".Message.broadcastOperation: object expected");
            message.broadcastOperation = $root.BroadcastOperationMessage.fromObject(object.broadcastOperation, long + 1);
        }
        if (object.ack != null) {
            if (typeof object.ack !== "object")
                throw TypeError(".Message.ack: object expected");
            message.ack = $root.AckMessage.fromObject(object.ack, long + 1);
        }
        if (object.rpcRequest != null) {
            if (typeof object.rpcRequest !== "object")
                throw TypeError(".Message.rpcRequest: object expected");
            message.rpcRequest = $root.RPCRequestMessage.fromObject(object.rpcRequest, long + 1);
        }
        if (object.rpcReply != null) {
            if (typeof object.rpcReply !== "object")
                throw TypeError(".Message.rpcReply: object expected");
            message.rpcReply = $root.RPCReplyMessage.fromObject(object.rpcReply, long + 1);
        }
        if (object.broadcastMarkers != null) {
            if (typeof object.broadcastMarkers !== "object")
                throw TypeError(".Message.broadcastMarkers: object expected");
            message.broadcastMarkers = $root.broadcastMarkersMessage.fromObject(object.broadcastMarkers, long + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from a Message message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Message
     * @static
     * @param {Message} message Message
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Message.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.promptInit != null && message.hasOwnProperty("promptInit")) {
            object.promptInit = $root.PromptInitMessage.toObject(message.promptInit, options);
            if (options.oneofs)
                object.message = "promptInit";
        }
        if (message.init != null && message.hasOwnProperty("init")) {
            object.init = $root.InitMessage.toObject(message.init, options);
            if (options.oneofs)
                object.message = "init";
        }
        if (message.update != null && message.hasOwnProperty("update")) {
            object.update = $root.UpdateMessage.toObject(message.update, options);
            if (options.oneofs)
                object.message = "update";
        }
        if (message.updatePresence != null && message.hasOwnProperty("updatePresence")) {
            object.updatePresence = $root.UpdatePresenceMessage.toObject(message.updatePresence, options);
            if (options.oneofs)
                object.message = "updatePresence";
        }
        if (message.broadcastPresences != null && message.hasOwnProperty("broadcastPresences")) {
            object.broadcastPresences = $root.BroadcastPresencesMessage.toObject(message.broadcastPresences, options);
            if (options.oneofs)
                object.message = "broadcastPresences";
        }
        if (message.broadcastOperation != null && message.hasOwnProperty("broadcastOperation")) {
            object.broadcastOperation = $root.BroadcastOperationMessage.toObject(message.broadcastOperation, options);
            if (options.oneofs)
                object.message = "broadcastOperation";
        }
        if (message.ack != null && message.hasOwnProperty("ack")) {
            object.ack = $root.AckMessage.toObject(message.ack, options);
            if (options.oneofs)
                object.message = "ack";
        }
        if (message.rpcRequest != null && message.hasOwnProperty("rpcRequest")) {
            object.rpcRequest = $root.RPCRequestMessage.toObject(message.rpcRequest, options);
            if (options.oneofs)
                object.message = "rpcRequest";
        }
        if (message.rpcReply != null && message.hasOwnProperty("rpcReply")) {
            object.rpcReply = $root.RPCReplyMessage.toObject(message.rpcReply, options);
            if (options.oneofs)
                object.message = "rpcReply";
        }
        if (message.broadcastMarkers != null && message.hasOwnProperty("broadcastMarkers")) {
            object.broadcastMarkers = $root.broadcastMarkersMessage.toObject(message.broadcastMarkers, options);
            if (options.oneofs)
                object.message = "broadcastMarkers";
        }
        return object;
    };

    /**
     * Converts this Message to JSON.
     * @function toJSON
     * @memberof Message
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Message.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Message
     * @function getTypeUrl
     * @memberof Message
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Message.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Message";
    };

    return Message;
})();

export const Presence = $root.Presence = (() => {

    /**
     * Properties of a Presence.
     * @exports IPresence
     * @interface IPresence
     * @property {Object.<string,string>|null} [data] Presence data
     * @property {number|Long|null} [joinTimestamp] Presence joinTimestamp
     * @property {number|Long|null} [updateTimestamp] Presence updateTimestamp
     * @property {string|null} [clientId] Presence clientId
     * @property {Object.<string,Uint8Array>|null} [positions] Presence positions
     */

    /**
     * Constructs a new Presence.
     * @exports Presence
     * @classdesc Represents a Presence.
     * @implements IPresence
     * @constructor
     * @param {IPresence=} [properties] Properties to set
     */
    function Presence(properties) {
        this.data = {};
        this.positions = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Presence data.
     * @member {Object.<string,string>} data
     * @memberof Presence
     * @instance
     */
    Presence.prototype.data = $util.emptyObject;

    /**
     * Presence joinTimestamp.
     * @member {number|Long|null|undefined} joinTimestamp
     * @memberof Presence
     * @instance
     */
    Presence.prototype.joinTimestamp = null;

    /**
     * Presence updateTimestamp.
     * @member {number|Long|null|undefined} updateTimestamp
     * @memberof Presence
     * @instance
     */
    Presence.prototype.updateTimestamp = null;

    /**
     * Presence clientId.
     * @member {string|null|undefined} clientId
     * @memberof Presence
     * @instance
     */
    Presence.prototype.clientId = null;

    /**
     * Presence positions.
     * @member {Object.<string,Uint8Array>} positions
     * @memberof Presence
     * @instance
     */
    Presence.prototype.positions = $util.emptyObject;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(Presence.prototype, "_joinTimestamp", {
        get: $util.oneOfGetter($oneOfFields = ["joinTimestamp"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(Presence.prototype, "_updateTimestamp", {
        get: $util.oneOfGetter($oneOfFields = ["updateTimestamp"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(Presence.prototype, "_clientId", {
        get: $util.oneOfGetter($oneOfFields = ["clientId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Presence instance using the specified properties.
     * @function create
     * @memberof Presence
     * @static
     * @param {IPresence=} [properties] Properties to set
     * @returns {Presence} Presence instance
     */
    Presence.create = function create(properties) {
        return new Presence(properties);
    };

    /**
     * Encodes the specified Presence message. Does not implicitly {@link Presence.verify|verify} messages.
     * @function encode
     * @memberof Presence
     * @static
     * @param {IPresence} message Presence message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Presence.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            for (let keys = Object.keys(message.data), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.data[keys[i]]).ldelim();
        if (message.joinTimestamp != null && Object.hasOwnProperty.call(message, "joinTimestamp"))
            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.joinTimestamp);
        if (message.updateTimestamp != null && Object.hasOwnProperty.call(message, "updateTimestamp"))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.updateTimestamp);
        if (message.clientId != null && Object.hasOwnProperty.call(message, "clientId"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.clientId);
        if (message.positions != null && Object.hasOwnProperty.call(message, "positions"))
            for (let keys = Object.keys(message.positions), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 5, wireType 2 =*/42).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).bytes(message.positions[keys[i]]).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Presence message, length delimited. Does not implicitly {@link Presence.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Presence
     * @static
     * @param {IPresence} message Presence message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Presence.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a Presence message from the specified reader or buffer.
     * @function decode
     * @memberof Presence
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Presence} Presence
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Presence.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Presence(), key, value;
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (message.data === $util.emptyObject)
                        message.data = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = "";
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.string();
                            break;
                        default:
                            reader.skipType(tag2 & 7, long);
                            break;
                        }
                    }
                    if (key === "__proto__")
                        $util.makeProp(message.data, key);
                    message.data[key] = value;
                    break;
                }
            case 2: {
                    message.joinTimestamp = reader.int64();
                    break;
                }
            case 3: {
                    message.updateTimestamp = reader.int64();
                    break;
                }
            case 4: {
                    message.clientId = reader.string();
                    break;
                }
            case 5: {
                    if (message.positions === $util.emptyObject)
                        message.positions = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = [];
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.bytes();
                            break;
                        default:
                            reader.skipType(tag2 & 7, long);
                            break;
                        }
                    }
                    if (key === "__proto__")
                        $util.makeProp(message.positions, key);
                    message.positions[key] = value;
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Presence message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Presence
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Presence} Presence
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Presence.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Presence message.
     * @function verify
     * @memberof Presence
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Presence.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.data != null && message.hasOwnProperty("data")) {
            if (!$util.isObject(message.data))
                return "data: object expected";
            let key = Object.keys(message.data);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isString(message.data[key[i]]))
                    return "data: string{k:string} expected";
        }
        if (message.joinTimestamp != null && message.hasOwnProperty("joinTimestamp")) {
            properties._joinTimestamp = 1;
            if (!$util.isInteger(message.joinTimestamp) && !(message.joinTimestamp && $util.isInteger(message.joinTimestamp.low) && $util.isInteger(message.joinTimestamp.high)))
                return "joinTimestamp: integer|Long expected";
        }
        if (message.updateTimestamp != null && message.hasOwnProperty("updateTimestamp")) {
            properties._updateTimestamp = 1;
            if (!$util.isInteger(message.updateTimestamp) && !(message.updateTimestamp && $util.isInteger(message.updateTimestamp.low) && $util.isInteger(message.updateTimestamp.high)))
                return "updateTimestamp: integer|Long expected";
        }
        if (message.clientId != null && message.hasOwnProperty("clientId")) {
            properties._clientId = 1;
            if (!$util.isString(message.clientId))
                return "clientId: string expected";
        }
        if (message.positions != null && message.hasOwnProperty("positions")) {
            if (!$util.isObject(message.positions))
                return "positions: object expected";
            let key = Object.keys(message.positions);
            for (let i = 0; i < key.length; ++i)
                if (!(message.positions[key[i]] && typeof message.positions[key[i]].length === "number" || $util.isString(message.positions[key[i]])))
                    return "positions: buffer{k:string} expected";
        }
        return null;
    };

    /**
     * Creates a Presence message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Presence
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Presence} Presence
     */
    Presence.fromObject = function fromObject(object, long) {
        if (object instanceof $root.Presence)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.Presence();
        if (object.data) {
            if (typeof object.data !== "object")
                throw TypeError(".Presence.data: object expected");
            message.data = {};
            for (let keys = Object.keys(object.data), i = 0; i < keys.length; ++i) {
                if (keys[i] === "__proto__")
                    $util.makeProp(message.data, keys[i]);
                message.data[keys[i]] = String(object.data[keys[i]]);
            }
        }
        if (object.joinTimestamp != null)
            if ($util.Long)
                (message.joinTimestamp = $util.Long.fromValue(object.joinTimestamp)).unsigned = false;
            else if (typeof object.joinTimestamp === "string")
                message.joinTimestamp = parseInt(object.joinTimestamp, 10);
            else if (typeof object.joinTimestamp === "number")
                message.joinTimestamp = object.joinTimestamp;
            else if (typeof object.joinTimestamp === "object")
                message.joinTimestamp = new $util.LongBits(object.joinTimestamp.low >>> 0, object.joinTimestamp.high >>> 0).toNumber();
        if (object.updateTimestamp != null)
            if ($util.Long)
                (message.updateTimestamp = $util.Long.fromValue(object.updateTimestamp)).unsigned = false;
            else if (typeof object.updateTimestamp === "string")
                message.updateTimestamp = parseInt(object.updateTimestamp, 10);
            else if (typeof object.updateTimestamp === "number")
                message.updateTimestamp = object.updateTimestamp;
            else if (typeof object.updateTimestamp === "object")
                message.updateTimestamp = new $util.LongBits(object.updateTimestamp.low >>> 0, object.updateTimestamp.high >>> 0).toNumber();
        if (object.clientId != null)
            message.clientId = String(object.clientId);
        if (object.positions) {
            if (typeof object.positions !== "object")
                throw TypeError(".Presence.positions: object expected");
            message.positions = {};
            for (let keys = Object.keys(object.positions), i = 0; i < keys.length; ++i) {
                if (keys[i] === "__proto__")
                    $util.makeProp(message.positions, keys[i]);
                if (typeof object.positions[keys[i]] === "string")
                    $util.base64.decode(object.positions[keys[i]], message.positions[keys[i]] = $util.newBuffer($util.base64.length(object.positions[keys[i]])), 0);
                else if (object.positions[keys[i]].length >= 0)
                    message.positions[keys[i]] = object.positions[keys[i]];
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Presence message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Presence
     * @static
     * @param {Presence} message Presence
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Presence.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.objects || options.defaults) {
            object.data = {};
            object.positions = {};
        }
        let keys2;
        if (message.data && (keys2 = Object.keys(message.data)).length) {
            object.data = {};
            for (let j = 0; j < keys2.length; ++j) {
                if (keys2[j] === "__proto__")
                    $util.makeProp(object.data, keys2[j]);
                object.data[keys2[j]] = message.data[keys2[j]];
            }
        }
        if (message.joinTimestamp != null && message.hasOwnProperty("joinTimestamp")) {
            if (typeof message.joinTimestamp === "number")
                object.joinTimestamp = options.longs === String ? String(message.joinTimestamp) : message.joinTimestamp;
            else
                object.joinTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.joinTimestamp) : options.longs === Number ? new $util.LongBits(message.joinTimestamp.low >>> 0, message.joinTimestamp.high >>> 0).toNumber() : message.joinTimestamp;
            if (options.oneofs)
                object._joinTimestamp = "joinTimestamp";
        }
        if (message.updateTimestamp != null && message.hasOwnProperty("updateTimestamp")) {
            if (typeof message.updateTimestamp === "number")
                object.updateTimestamp = options.longs === String ? String(message.updateTimestamp) : message.updateTimestamp;
            else
                object.updateTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimestamp) : options.longs === Number ? new $util.LongBits(message.updateTimestamp.low >>> 0, message.updateTimestamp.high >>> 0).toNumber() : message.updateTimestamp;
            if (options.oneofs)
                object._updateTimestamp = "updateTimestamp";
        }
        if (message.clientId != null && message.hasOwnProperty("clientId")) {
            object.clientId = message.clientId;
            if (options.oneofs)
                object._clientId = "clientId";
        }
        if (message.positions && (keys2 = Object.keys(message.positions)).length) {
            object.positions = {};
            for (let j = 0; j < keys2.length; ++j) {
                if (keys2[j] === "__proto__")
                    $util.makeProp(object.positions, keys2[j]);
                object.positions[keys2[j]] = options.bytes === String ? $util.base64.encode(message.positions[keys2[j]], 0, message.positions[keys2[j]].length) : options.bytes === Array ? Array.prototype.slice.call(message.positions[keys2[j]]) : message.positions[keys2[j]];
            }
        }
        return object;
    };

    /**
     * Converts this Presence to JSON.
     * @function toJSON
     * @memberof Presence
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Presence.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Presence
     * @function getTypeUrl
     * @memberof Presence
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Presence.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Presence";
    };

    return Presence;
})();

export const ContentOperation = $root.ContentOperation = (() => {

    /**
     * Properties of a ContentOperation.
     * @exports IContentOperation
     * @interface IContentOperation
     * @property {string|null} [id] ContentOperation id
     * @property {ContentOperationStatus|null} [status] ContentOperation status
     * @property {number|Long|null} [createdAt] ContentOperation createdAt
     * @property {number|Long|null} [updatedAt] ContentOperation updatedAt
     * @property {number|null} [updateId] ContentOperation updateId
     * @property {number|null} [expireAfter] ContentOperation expireAfter
     * @property {number|null} [cursor] ContentOperation cursor
     * @property {number|null} [target] ContentOperation target
     * @property {Object.<string,string>|null} [payload] ContentOperation payload
     */

    /**
     * Constructs a new ContentOperation.
     * @exports ContentOperation
     * @classdesc Represents a ContentOperation.
     * @implements IContentOperation
     * @constructor
     * @param {IContentOperation=} [properties] Properties to set
     */
    function ContentOperation(properties) {
        this.payload = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ContentOperation id.
     * @member {string|null|undefined} id
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.id = null;

    /**
     * ContentOperation status.
     * @member {ContentOperationStatus|null|undefined} status
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.status = null;

    /**
     * ContentOperation createdAt.
     * @member {number|Long|null|undefined} createdAt
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.createdAt = null;

    /**
     * ContentOperation updatedAt.
     * @member {number|Long|null|undefined} updatedAt
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.updatedAt = null;

    /**
     * ContentOperation updateId.
     * @member {number|null|undefined} updateId
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.updateId = null;

    /**
     * ContentOperation expireAfter.
     * @member {number|null|undefined} expireAfter
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.expireAfter = null;

    /**
     * ContentOperation cursor.
     * @member {number|null|undefined} cursor
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.cursor = null;

    /**
     * ContentOperation target.
     * @member {number|null|undefined} target
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.target = null;

    /**
     * ContentOperation payload.
     * @member {Object.<string,string>} payload
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.payload = $util.emptyObject;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ContentOperation.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ContentOperation.prototype, "_status", {
        get: $util.oneOfGetter($oneOfFields = ["status"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ContentOperation.prototype, "_createdAt", {
        get: $util.oneOfGetter($oneOfFields = ["createdAt"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ContentOperation.prototype, "_updatedAt", {
        get: $util.oneOfGetter($oneOfFields = ["updatedAt"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ContentOperation.prototype, "_updateId", {
        get: $util.oneOfGetter($oneOfFields = ["updateId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ContentOperation.prototype, "_expireAfter", {
        get: $util.oneOfGetter($oneOfFields = ["expireAfter"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ContentOperation.prototype, "_cursor", {
        get: $util.oneOfGetter($oneOfFields = ["cursor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ContentOperation.prototype, "_target", {
        get: $util.oneOfGetter($oneOfFields = ["target"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new ContentOperation instance using the specified properties.
     * @function create
     * @memberof ContentOperation
     * @static
     * @param {IContentOperation=} [properties] Properties to set
     * @returns {ContentOperation} ContentOperation instance
     */
    ContentOperation.create = function create(properties) {
        return new ContentOperation(properties);
    };

    /**
     * Encodes the specified ContentOperation message. Does not implicitly {@link ContentOperation.verify|verify} messages.
     * @function encode
     * @memberof ContentOperation
     * @static
     * @param {IContentOperation} message ContentOperation message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContentOperation.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
        if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.createdAt);
        if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.updatedAt);
        if (message.updateId != null && Object.hasOwnProperty.call(message, "updateId"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.updateId);
        if (message.expireAfter != null && Object.hasOwnProperty.call(message, "expireAfter"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.expireAfter);
        if (message.cursor != null && Object.hasOwnProperty.call(message, "cursor"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.cursor);
        if (message.target != null && Object.hasOwnProperty.call(message, "target"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.target);
        if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
            for (let keys = Object.keys(message.payload), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 9, wireType 2 =*/74).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.payload[keys[i]]).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ContentOperation message, length delimited. Does not implicitly {@link ContentOperation.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ContentOperation
     * @static
     * @param {IContentOperation} message ContentOperation message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContentOperation.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a ContentOperation message from the specified reader or buffer.
     * @function decode
     * @memberof ContentOperation
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ContentOperation} ContentOperation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContentOperation.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ContentOperation(), key, value;
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.status = reader.int32();
                    break;
                }
            case 3: {
                    message.createdAt = reader.int64();
                    break;
                }
            case 4: {
                    message.updatedAt = reader.int64();
                    break;
                }
            case 5: {
                    message.updateId = reader.int32();
                    break;
                }
            case 6: {
                    message.expireAfter = reader.int32();
                    break;
                }
            case 7: {
                    message.cursor = reader.int32();
                    break;
                }
            case 8: {
                    message.target = reader.int32();
                    break;
                }
            case 9: {
                    if (message.payload === $util.emptyObject)
                        message.payload = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = "";
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.string();
                            break;
                        default:
                            reader.skipType(tag2 & 7, long);
                            break;
                        }
                    }
                    if (key === "__proto__")
                        $util.makeProp(message.payload, key);
                    message.payload[key] = value;
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ContentOperation message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ContentOperation
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ContentOperation} ContentOperation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContentOperation.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ContentOperation message.
     * @function verify
     * @memberof ContentOperation
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ContentOperation.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            properties._id = 1;
            if (!$util.isString(message.id))
                return "id: string expected";
        }
        if (message.status != null && message.hasOwnProperty("status")) {
            properties._status = 1;
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        }
        if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
            properties._createdAt = 1;
            if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                return "createdAt: integer|Long expected";
        }
        if (message.updatedAt != null && message.hasOwnProperty("updatedAt")) {
            properties._updatedAt = 1;
            if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
                return "updatedAt: integer|Long expected";
        }
        if (message.updateId != null && message.hasOwnProperty("updateId")) {
            properties._updateId = 1;
            if (!$util.isInteger(message.updateId))
                return "updateId: integer expected";
        }
        if (message.expireAfter != null && message.hasOwnProperty("expireAfter")) {
            properties._expireAfter = 1;
            if (!$util.isInteger(message.expireAfter))
                return "expireAfter: integer expected";
        }
        if (message.cursor != null && message.hasOwnProperty("cursor")) {
            properties._cursor = 1;
            if (!$util.isInteger(message.cursor))
                return "cursor: integer expected";
        }
        if (message.target != null && message.hasOwnProperty("target")) {
            properties._target = 1;
            if (!$util.isInteger(message.target))
                return "target: integer expected";
        }
        if (message.payload != null && message.hasOwnProperty("payload")) {
            if (!$util.isObject(message.payload))
                return "payload: object expected";
            let key = Object.keys(message.payload);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isString(message.payload[key[i]]))
                    return "payload: string{k:string} expected";
        }
        return null;
    };

    /**
     * Creates a ContentOperation message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ContentOperation
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ContentOperation} ContentOperation
     */
    ContentOperation.fromObject = function fromObject(object, long) {
        if (object instanceof $root.ContentOperation)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.ContentOperation();
        if (object.id != null)
            message.id = String(object.id);
        switch (object.status) {
        default:
            if (typeof object.status === "number") {
                message.status = object.status;
                break;
            }
            break;
        case "STARTING":
        case 0:
            message.status = 0;
            break;
        case "RUNNING":
        case 1:
            message.status = 1;
            break;
        case "SUCCESS":
        case 2:
            message.status = 2;
            break;
        case "ERROR":
        case 3:
            message.status = 3;
            break;
        }
        if (object.createdAt != null)
            if ($util.Long)
                (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
            else if (typeof object.createdAt === "string")
                message.createdAt = parseInt(object.createdAt, 10);
            else if (typeof object.createdAt === "number")
                message.createdAt = object.createdAt;
            else if (typeof object.createdAt === "object")
                message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
        if (object.updatedAt != null)
            if ($util.Long)
                (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = false;
            else if (typeof object.updatedAt === "string")
                message.updatedAt = parseInt(object.updatedAt, 10);
            else if (typeof object.updatedAt === "number")
                message.updatedAt = object.updatedAt;
            else if (typeof object.updatedAt === "object")
                message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber();
        if (object.updateId != null)
            message.updateId = object.updateId | 0;
        if (object.expireAfter != null)
            message.expireAfter = object.expireAfter | 0;
        if (object.cursor != null)
            message.cursor = object.cursor | 0;
        if (object.target != null)
            message.target = object.target | 0;
        if (object.payload) {
            if (typeof object.payload !== "object")
                throw TypeError(".ContentOperation.payload: object expected");
            message.payload = {};
            for (let keys = Object.keys(object.payload), i = 0; i < keys.length; ++i) {
                if (keys[i] === "__proto__")
                    $util.makeProp(message.payload, keys[i]);
                message.payload[keys[i]] = String(object.payload[keys[i]]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ContentOperation message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ContentOperation
     * @static
     * @param {ContentOperation} message ContentOperation
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ContentOperation.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.objects || options.defaults)
            object.payload = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            object.id = message.id;
            if (options.oneofs)
                object._id = "id";
        }
        if (message.status != null && message.hasOwnProperty("status")) {
            object.status = options.enums === String ? $root.ContentOperationStatus[message.status] === undefined ? message.status : $root.ContentOperationStatus[message.status] : message.status;
            if (options.oneofs)
                object._status = "status";
        }
        if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
            if (typeof message.createdAt === "number")
                object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
            else
                object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (options.oneofs)
                object._createdAt = "createdAt";
        }
        if (message.updatedAt != null && message.hasOwnProperty("updatedAt")) {
            if (typeof message.updatedAt === "number")
                object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
            else
                object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber() : message.updatedAt;
            if (options.oneofs)
                object._updatedAt = "updatedAt";
        }
        if (message.updateId != null && message.hasOwnProperty("updateId")) {
            object.updateId = message.updateId;
            if (options.oneofs)
                object._updateId = "updateId";
        }
        if (message.expireAfter != null && message.hasOwnProperty("expireAfter")) {
            object.expireAfter = message.expireAfter;
            if (options.oneofs)
                object._expireAfter = "expireAfter";
        }
        if (message.cursor != null && message.hasOwnProperty("cursor")) {
            object.cursor = message.cursor;
            if (options.oneofs)
                object._cursor = "cursor";
        }
        if (message.target != null && message.hasOwnProperty("target")) {
            object.target = message.target;
            if (options.oneofs)
                object._target = "target";
        }
        let keys2;
        if (message.payload && (keys2 = Object.keys(message.payload)).length) {
            object.payload = {};
            for (let j = 0; j < keys2.length; ++j) {
                if (keys2[j] === "__proto__")
                    $util.makeProp(object.payload, keys2[j]);
                object.payload[keys2[j]] = message.payload[keys2[j]];
            }
        }
        return object;
    };

    /**
     * Converts this ContentOperation to JSON.
     * @function toJSON
     * @memberof ContentOperation
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ContentOperation.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ContentOperation
     * @function getTypeUrl
     * @memberof ContentOperation
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ContentOperation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ContentOperation";
    };

    return ContentOperation;
})();

export const DebugLog = $root.DebugLog = (() => {

    /**
     * Properties of a DebugLog.
     * @exports IDebugLog
     * @interface IDebugLog
     * @property {Array.<IDebugLogUpdate>|null} [updates] DebugLog updates
     */

    /**
     * Constructs a new DebugLog.
     * @exports DebugLog
     * @classdesc Represents a DebugLog.
     * @implements IDebugLog
     * @constructor
     * @param {IDebugLog=} [properties] Properties to set
     */
    function DebugLog(properties) {
        this.updates = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DebugLog updates.
     * @member {Array.<IDebugLogUpdate>} updates
     * @memberof DebugLog
     * @instance
     */
    DebugLog.prototype.updates = $util.emptyArray;

    /**
     * Creates a new DebugLog instance using the specified properties.
     * @function create
     * @memberof DebugLog
     * @static
     * @param {IDebugLog=} [properties] Properties to set
     * @returns {DebugLog} DebugLog instance
     */
    DebugLog.create = function create(properties) {
        return new DebugLog(properties);
    };

    /**
     * Encodes the specified DebugLog message. Does not implicitly {@link DebugLog.verify|verify} messages.
     * @function encode
     * @memberof DebugLog
     * @static
     * @param {IDebugLog} message DebugLog message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DebugLog.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.updates != null && message.updates.length)
            for (let i = 0; i < message.updates.length; ++i)
                $root.DebugLogUpdate.encode(message.updates[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified DebugLog message, length delimited. Does not implicitly {@link DebugLog.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DebugLog
     * @static
     * @param {IDebugLog} message DebugLog message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DebugLog.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a DebugLog message from the specified reader or buffer.
     * @function decode
     * @memberof DebugLog
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DebugLog} DebugLog
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DebugLog.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLog();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.updates && message.updates.length))
                        message.updates = [];
                    message.updates.push($root.DebugLogUpdate.decode(reader, reader.uint32(), undefined, long + 1));
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DebugLog message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DebugLog
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DebugLog} DebugLog
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DebugLog.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DebugLog message.
     * @function verify
     * @memberof DebugLog
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DebugLog.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        if (message.updates != null && message.hasOwnProperty("updates")) {
            if (!Array.isArray(message.updates))
                return "updates: array expected";
            for (let i = 0; i < message.updates.length; ++i) {
                let error = $root.DebugLogUpdate.verify(message.updates[i], long + 1);
                if (error)
                    return "updates." + error;
            }
        }
        return null;
    };

    /**
     * Creates a DebugLog message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DebugLog
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DebugLog} DebugLog
     */
    DebugLog.fromObject = function fromObject(object, long) {
        if (object instanceof $root.DebugLog)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.DebugLog();
        if (object.updates) {
            if (!Array.isArray(object.updates))
                throw TypeError(".DebugLog.updates: array expected");
            message.updates = [];
            for (let i = 0; i < object.updates.length; ++i) {
                if (typeof object.updates[i] !== "object")
                    throw TypeError(".DebugLog.updates: object expected");
                message.updates[i] = $root.DebugLogUpdate.fromObject(object.updates[i], long + 1);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a DebugLog message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DebugLog
     * @static
     * @param {DebugLog} message DebugLog
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DebugLog.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.updates = [];
        if (message.updates && message.updates.length) {
            object.updates = [];
            for (let j = 0; j < message.updates.length; ++j)
                object.updates[j] = $root.DebugLogUpdate.toObject(message.updates[j], options);
        }
        return object;
    };

    /**
     * Converts this DebugLog to JSON.
     * @function toJSON
     * @memberof DebugLog
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DebugLog.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DebugLog
     * @function getTypeUrl
     * @memberof DebugLog
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DebugLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DebugLog";
    };

    return DebugLog;
})();

export const DebugLogUpdate = $root.DebugLogUpdate = (() => {

    /**
     * Properties of a DebugLogUpdate.
     * @exports IDebugLogUpdate
     * @interface IDebugLogUpdate
     * @property {number|Long|null} [timestamp] DebugLogUpdate timestamp
     * @property {Uint8Array|null} [update] DebugLogUpdate update
     * @property {string|null} [origin] DebugLogUpdate origin
     */

    /**
     * Constructs a new DebugLogUpdate.
     * @exports DebugLogUpdate
     * @classdesc Represents a DebugLogUpdate.
     * @implements IDebugLogUpdate
     * @constructor
     * @param {IDebugLogUpdate=} [properties] Properties to set
     */
    function DebugLogUpdate(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DebugLogUpdate timestamp.
     * @member {number|Long|null|undefined} timestamp
     * @memberof DebugLogUpdate
     * @instance
     */
    DebugLogUpdate.prototype.timestamp = null;

    /**
     * DebugLogUpdate update.
     * @member {Uint8Array|null|undefined} update
     * @memberof DebugLogUpdate
     * @instance
     */
    DebugLogUpdate.prototype.update = null;

    /**
     * DebugLogUpdate origin.
     * @member {string|null|undefined} origin
     * @memberof DebugLogUpdate
     * @instance
     */
    DebugLogUpdate.prototype.origin = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(DebugLogUpdate.prototype, "_timestamp", {
        get: $util.oneOfGetter($oneOfFields = ["timestamp"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(DebugLogUpdate.prototype, "_update", {
        get: $util.oneOfGetter($oneOfFields = ["update"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(DebugLogUpdate.prototype, "_origin", {
        get: $util.oneOfGetter($oneOfFields = ["origin"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new DebugLogUpdate instance using the specified properties.
     * @function create
     * @memberof DebugLogUpdate
     * @static
     * @param {IDebugLogUpdate=} [properties] Properties to set
     * @returns {DebugLogUpdate} DebugLogUpdate instance
     */
    DebugLogUpdate.create = function create(properties) {
        return new DebugLogUpdate(properties);
    };

    /**
     * Encodes the specified DebugLogUpdate message. Does not implicitly {@link DebugLogUpdate.verify|verify} messages.
     * @function encode
     * @memberof DebugLogUpdate
     * @static
     * @param {IDebugLogUpdate} message DebugLogUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DebugLogUpdate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.timestamp);
        if (message.update != null && Object.hasOwnProperty.call(message, "update"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.update);
        if (message.origin != null && Object.hasOwnProperty.call(message, "origin"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.origin);
        return writer;
    };

    /**
     * Encodes the specified DebugLogUpdate message, length delimited. Does not implicitly {@link DebugLogUpdate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DebugLogUpdate
     * @static
     * @param {IDebugLogUpdate} message DebugLogUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DebugLogUpdate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a DebugLogUpdate message from the specified reader or buffer.
     * @function decode
     * @memberof DebugLogUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DebugLogUpdate} DebugLogUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DebugLogUpdate.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLogUpdate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.timestamp = reader.int64();
                    break;
                }
            case 2: {
                    message.update = reader.bytes();
                    break;
                }
            case 3: {
                    message.origin = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DebugLogUpdate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DebugLogUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DebugLogUpdate} DebugLogUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DebugLogUpdate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DebugLogUpdate message.
     * @function verify
     * @memberof DebugLogUpdate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DebugLogUpdate.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.timestamp != null && message.hasOwnProperty("timestamp")) {
            properties._timestamp = 1;
            if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                return "timestamp: integer|Long expected";
        }
        if (message.update != null && message.hasOwnProperty("update")) {
            properties._update = 1;
            if (!(message.update && typeof message.update.length === "number" || $util.isString(message.update)))
                return "update: buffer expected";
        }
        if (message.origin != null && message.hasOwnProperty("origin")) {
            properties._origin = 1;
            if (!$util.isString(message.origin))
                return "origin: string expected";
        }
        return null;
    };

    /**
     * Creates a DebugLogUpdate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DebugLogUpdate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DebugLogUpdate} DebugLogUpdate
     */
    DebugLogUpdate.fromObject = function fromObject(object, long) {
        if (object instanceof $root.DebugLogUpdate)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.DebugLogUpdate();
        if (object.timestamp != null)
            if ($util.Long)
                (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
            else if (typeof object.timestamp === "string")
                message.timestamp = parseInt(object.timestamp, 10);
            else if (typeof object.timestamp === "number")
                message.timestamp = object.timestamp;
            else if (typeof object.timestamp === "object")
                message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
        if (object.update != null)
            if (typeof object.update === "string")
                $util.base64.decode(object.update, message.update = $util.newBuffer($util.base64.length(object.update)), 0);
            else if (object.update.length >= 0)
                message.update = object.update;
        if (object.origin != null)
            message.origin = String(object.origin);
        return message;
    };

    /**
     * Creates a plain object from a DebugLogUpdate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DebugLogUpdate
     * @static
     * @param {DebugLogUpdate} message DebugLogUpdate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DebugLogUpdate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.timestamp != null && message.hasOwnProperty("timestamp")) {
            if (typeof message.timestamp === "number")
                object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
            else
                object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
            if (options.oneofs)
                object._timestamp = "timestamp";
        }
        if (message.update != null && message.hasOwnProperty("update")) {
            object.update = options.bytes === String ? $util.base64.encode(message.update, 0, message.update.length) : options.bytes === Array ? Array.prototype.slice.call(message.update) : message.update;
            if (options.oneofs)
                object._update = "update";
        }
        if (message.origin != null && message.hasOwnProperty("origin")) {
            object.origin = message.origin;
            if (options.oneofs)
                object._origin = "origin";
        }
        return object;
    };

    /**
     * Converts this DebugLogUpdate to JSON.
     * @function toJSON
     * @memberof DebugLogUpdate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DebugLogUpdate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DebugLogUpdate
     * @function getTypeUrl
     * @memberof DebugLogUpdate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DebugLogUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DebugLogUpdate";
    };

    return DebugLogUpdate;
})();

export const Markers = $root.Markers = (() => {

    /**
     * Constructs a new Markers service.
     * @exports Markers
     * @classdesc Represents a Markers
     * @extends $protobuf.rpc.Service
     * @constructor
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     */
    function Markers(rpcImpl, requestDelimited, responseDelimited) {
        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
    }

    (Markers.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = Markers;

    /**
     * Creates new Markers service using the specified rpc implementation.
     * @function create
     * @memberof Markers
     * @static
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     * @returns {Markers} RPC service. Useful where requests and/or responses are streamed.
     */
    Markers.create = function create(rpcImpl, requestDelimited, responseDelimited) {
        return new this(rpcImpl, requestDelimited, responseDelimited);
    };

    /**
     * Callback as used by {@link Markers#createMarker}.
     * @memberof Markers
     * @typedef createMarkerCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {CreateMarkerReply} [response] CreateMarkerReply
     */

    /**
     * Create a new content marker.
     * @function createMarker
     * @memberof Markers
     * @instance
     * @param {ICreateMarkerRequest} request CreateMarkerRequest message or plain object
     * @param {Markers.createMarkerCallback} callback Node-style callback called with the error, if any, and CreateMarkerReply
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(Markers.prototype.createMarker = function createMarker(request, callback) {
        return $protobuf.rpc.Service.prototype.rpcCall.call(this, createMarker, $root.CreateMarkerRequest, $root.CreateMarkerReply, request, callback);
    }, "name", { value: "createMarker" });

    /**
     * Create a new content marker.
     * @function createMarker
     * @memberof Markers
     * @instance
     * @param {ICreateMarkerRequest} request CreateMarkerRequest message or plain object
     * @returns {Promise<CreateMarkerReply>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link Markers#removeMarker}.
     * @memberof Markers
     * @typedef removeMarkerCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {RemoveMarkerReply} [response] RemoveMarkerReply
     */

    /**
     * Remove an existing content marker.
     * @function removeMarker
     * @memberof Markers
     * @instance
     * @param {IRemoveMarkerRequest} request RemoveMarkerRequest message or plain object
     * @param {Markers.removeMarkerCallback} callback Node-style callback called with the error, if any, and RemoveMarkerReply
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(Markers.prototype.removeMarker = function removeMarker(request, callback) {
        return $protobuf.rpc.Service.prototype.rpcCall.call(this, removeMarker, $root.RemoveMarkerRequest, $root.RemoveMarkerReply, request, callback);
    }, "name", { value: "removeMarker" });

    /**
     * Remove an existing content marker.
     * @function removeMarker
     * @memberof Markers
     * @instance
     * @param {IRemoveMarkerRequest} request RemoveMarkerRequest message or plain object
     * @returns {Promise<RemoveMarkerReply>} Promise
     * @variation 2
     */

    return Markers;
})();

export const Content = $root.Content = (() => {

    /**
     * Constructs a new Content service.
     * @exports Content
     * @classdesc Represents a Content
     * @extends $protobuf.rpc.Service
     * @constructor
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     */
    function Content(rpcImpl, requestDelimited, responseDelimited) {
        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
    }

    (Content.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = Content;

    /**
     * Creates new Content service using the specified rpc implementation.
     * @function create
     * @memberof Content
     * @static
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     * @returns {Content} RPC service. Useful where requests and/or responses are streamed.
     */
    Content.create = function create(rpcImpl, requestDelimited, responseDelimited) {
        return new this(rpcImpl, requestDelimited, responseDelimited);
    };

    /**
     * Callback as used by {@link Content#duplicatePage}.
     * @memberof Content
     * @typedef duplicatePageCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {DuplicatePageReply} [response] DuplicatePageReply
     */

    /**
     * Duplicate a page (and its subpages) within the current branch.
     * 
     * Unlike a client-side duplicate, this runs on the runtime so it can capture
     * unflushed realtime edits of the source pages into the copies.
     * @function duplicatePage
     * @memberof Content
     * @instance
     * @param {IDuplicatePageRequest} request DuplicatePageRequest message or plain object
     * @param {Content.duplicatePageCallback} callback Node-style callback called with the error, if any, and DuplicatePageReply
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(Content.prototype.duplicatePage = function duplicatePage(request, callback) {
        return $protobuf.rpc.Service.prototype.rpcCall.call(this, duplicatePage, $root.DuplicatePageRequest, $root.DuplicatePageReply, request, callback);
    }, "name", { value: "duplicatePage" });

    /**
     * Duplicate a page (and its subpages) within the current branch.
     * 
     * Unlike a client-side duplicate, this runs on the runtime so it can capture
     * unflushed realtime edits of the source pages into the copies.
     * @function duplicatePage
     * @memberof Content
     * @instance
     * @param {IDuplicatePageRequest} request DuplicatePageRequest message or plain object
     * @returns {Promise<DuplicatePageReply>} Promise
     * @variation 2
     */

    return Content;
})();

export const Connection = $root.Connection = (() => {

    /**
     * Constructs a new Connection service.
     * @exports Connection
     * @classdesc Represents a Connection
     * @extends $protobuf.rpc.Service
     * @constructor
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     */
    function Connection(rpcImpl, requestDelimited, responseDelimited) {
        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
    }

    (Connection.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = Connection;

    /**
     * Creates new Connection service using the specified rpc implementation.
     * @function create
     * @memberof Connection
     * @static
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     * @returns {Connection} RPC service. Useful where requests and/or responses are streamed.
     */
    Connection.create = function create(rpcImpl, requestDelimited, responseDelimited) {
        return new this(rpcImpl, requestDelimited, responseDelimited);
    };

    /**
     * Callback as used by {@link Connection#subscribe}.
     * @memberof Connection
     * @typedef subscribeCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {SubscribeReply} [response] SubscribeReply
     */

    /**
     * Subscribe to a specific resource, mapping an integer ID to a full identifier.
     * @function subscribe
     * @memberof Connection
     * @instance
     * @param {ISubscribeRequest} request SubscribeRequest message or plain object
     * @param {Connection.subscribeCallback} callback Node-style callback called with the error, if any, and SubscribeReply
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(Connection.prototype.subscribe = function subscribe(request, callback) {
        return $protobuf.rpc.Service.prototype.rpcCall.call(this, subscribe, $root.SubscribeRequest, $root.SubscribeReply, request, callback);
    }, "name", { value: "subscribe" });

    /**
     * Subscribe to a specific resource, mapping an integer ID to a full identifier.
     * @function subscribe
     * @memberof Connection
     * @instance
     * @param {ISubscribeRequest} request SubscribeRequest message or plain object
     * @returns {Promise<SubscribeReply>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link Connection#unsubscribe}.
     * @memberof Connection
     * @typedef unsubscribeCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {UnsubscribeReply} [response] UnsubscribeReply
     */

    /**
     * Unsubscribe from a specific resource.
     * @function unsubscribe
     * @memberof Connection
     * @instance
     * @param {IUnsubscribeRequest} request UnsubscribeRequest message or plain object
     * @param {Connection.unsubscribeCallback} callback Node-style callback called with the error, if any, and UnsubscribeReply
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(Connection.prototype.unsubscribe = function unsubscribe(request, callback) {
        return $protobuf.rpc.Service.prototype.rpcCall.call(this, unsubscribe, $root.UnsubscribeRequest, $root.UnsubscribeReply, request, callback);
    }, "name", { value: "unsubscribe" });

    /**
     * Unsubscribe from a specific resource.
     * @function unsubscribe
     * @memberof Connection
     * @instance
     * @param {IUnsubscribeRequest} request UnsubscribeRequest message or plain object
     * @returns {Promise<UnsubscribeReply>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link Connection#reconnect}.
     * @memberof Connection
     * @typedef reconnectCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {ReconnectReply} [response] ReconnectReply
     */

    /**
     * Signal the other side to reconnect for a given subscription ID.
     * Sent by either side when a message arrives for a subscription ID that has
     * no associated state (no identifier on the server, no V2Socket on the client).
     * @function reconnect
     * @memberof Connection
     * @instance
     * @param {IReconnectRequest} request ReconnectRequest message or plain object
     * @param {Connection.reconnectCallback} callback Node-style callback called with the error, if any, and ReconnectReply
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(Connection.prototype.reconnect = function reconnect(request, callback) {
        return $protobuf.rpc.Service.prototype.rpcCall.call(this, reconnect, $root.ReconnectRequest, $root.ReconnectReply, request, callback);
    }, "name", { value: "reconnect" });

    /**
     * Signal the other side to reconnect for a given subscription ID.
     * Sent by either side when a message arrives for a subscription ID that has
     * no associated state (no identifier on the server, no V2Socket on the client).
     * @function reconnect
     * @memberof Connection
     * @instance
     * @param {IReconnectRequest} request ReconnectRequest message or plain object
     * @returns {Promise<ReconnectReply>} Promise
     * @variation 2
     */

    return Connection;
})();

export const CreateMarkerRequest = $root.CreateMarkerRequest = (() => {

    /**
     * Properties of a CreateMarkerRequest.
     * @exports ICreateMarkerRequest
     * @interface ICreateMarkerRequest
     * @property {Uint8Array|null} [anchorRelativePosition] CreateMarkerRequest anchorRelativePosition
     * @property {Uint8Array|null} [focusRelativePosition] CreateMarkerRequest focusRelativePosition
     * @property {Uint8Array|null} [content] CreateMarkerRequest content
     * @property {Object.<string,string>|null} [data] CreateMarkerRequest data
     * @property {ContentMarkerType|null} [type] CreateMarkerRequest type
     */

    /**
     * Constructs a new CreateMarkerRequest.
     * @exports CreateMarkerRequest
     * @classdesc Represents a CreateMarkerRequest.
     * @implements ICreateMarkerRequest
     * @constructor
     * @param {ICreateMarkerRequest=} [properties] Properties to set
     */
    function CreateMarkerRequest(properties) {
        this.data = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CreateMarkerRequest anchorRelativePosition.
     * @member {Uint8Array|null|undefined} anchorRelativePosition
     * @memberof CreateMarkerRequest
     * @instance
     */
    CreateMarkerRequest.prototype.anchorRelativePosition = null;

    /**
     * CreateMarkerRequest focusRelativePosition.
     * @member {Uint8Array|null|undefined} focusRelativePosition
     * @memberof CreateMarkerRequest
     * @instance
     */
    CreateMarkerRequest.prototype.focusRelativePosition = null;

    /**
     * CreateMarkerRequest content.
     * @member {Uint8Array} content
     * @memberof CreateMarkerRequest
     * @instance
     */
    CreateMarkerRequest.prototype.content = $util.newBuffer([]);

    /**
     * CreateMarkerRequest data.
     * @member {Object.<string,string>} data
     * @memberof CreateMarkerRequest
     * @instance
     */
    CreateMarkerRequest.prototype.data = $util.emptyObject;

    /**
     * CreateMarkerRequest type.
     * @member {ContentMarkerType|null|undefined} type
     * @memberof CreateMarkerRequest
     * @instance
     */
    CreateMarkerRequest.prototype.type = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(CreateMarkerRequest.prototype, "_anchorRelativePosition", {
        get: $util.oneOfGetter($oneOfFields = ["anchorRelativePosition"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(CreateMarkerRequest.prototype, "_focusRelativePosition", {
        get: $util.oneOfGetter($oneOfFields = ["focusRelativePosition"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(CreateMarkerRequest.prototype, "_type", {
        get: $util.oneOfGetter($oneOfFields = ["type"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new CreateMarkerRequest instance using the specified properties.
     * @function create
     * @memberof CreateMarkerRequest
     * @static
     * @param {ICreateMarkerRequest=} [properties] Properties to set
     * @returns {CreateMarkerRequest} CreateMarkerRequest instance
     */
    CreateMarkerRequest.create = function create(properties) {
        return new CreateMarkerRequest(properties);
    };

    /**
     * Encodes the specified CreateMarkerRequest message. Does not implicitly {@link CreateMarkerRequest.verify|verify} messages.
     * @function encode
     * @memberof CreateMarkerRequest
     * @static
     * @param {ICreateMarkerRequest} message CreateMarkerRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateMarkerRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.anchorRelativePosition != null && Object.hasOwnProperty.call(message, "anchorRelativePosition"))
            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.anchorRelativePosition);
        if (message.focusRelativePosition != null && Object.hasOwnProperty.call(message, "focusRelativePosition"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.focusRelativePosition);
        if (message.content != null && Object.hasOwnProperty.call(message, "content"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.content);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            for (let keys = Object.keys(message.data), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 4, wireType 2 =*/34).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.data[keys[i]]).ldelim();
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.type);
        return writer;
    };

    /**
     * Encodes the specified CreateMarkerRequest message, length delimited. Does not implicitly {@link CreateMarkerRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CreateMarkerRequest
     * @static
     * @param {ICreateMarkerRequest} message CreateMarkerRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateMarkerRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a CreateMarkerRequest message from the specified reader or buffer.
     * @function decode
     * @memberof CreateMarkerRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CreateMarkerRequest} CreateMarkerRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateMarkerRequest.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CreateMarkerRequest(), key, value;
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.anchorRelativePosition = reader.bytes();
                    break;
                }
            case 2: {
                    message.focusRelativePosition = reader.bytes();
                    break;
                }
            case 3: {
                    message.content = reader.bytes();
                    break;
                }
            case 4: {
                    if (message.data === $util.emptyObject)
                        message.data = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = "";
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.string();
                            break;
                        default:
                            reader.skipType(tag2 & 7, long);
                            break;
                        }
                    }
                    if (key === "__proto__")
                        $util.makeProp(message.data, key);
                    message.data[key] = value;
                    break;
                }
            case 5: {
                    message.type = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CreateMarkerRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CreateMarkerRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CreateMarkerRequest} CreateMarkerRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateMarkerRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CreateMarkerRequest message.
     * @function verify
     * @memberof CreateMarkerRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CreateMarkerRequest.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.anchorRelativePosition != null && message.hasOwnProperty("anchorRelativePosition")) {
            properties._anchorRelativePosition = 1;
            if (!(message.anchorRelativePosition && typeof message.anchorRelativePosition.length === "number" || $util.isString(message.anchorRelativePosition)))
                return "anchorRelativePosition: buffer expected";
        }
        if (message.focusRelativePosition != null && message.hasOwnProperty("focusRelativePosition")) {
            properties._focusRelativePosition = 1;
            if (!(message.focusRelativePosition && typeof message.focusRelativePosition.length === "number" || $util.isString(message.focusRelativePosition)))
                return "focusRelativePosition: buffer expected";
        }
        if (message.content != null && message.hasOwnProperty("content"))
            if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                return "content: buffer expected";
        if (message.data != null && message.hasOwnProperty("data")) {
            if (!$util.isObject(message.data))
                return "data: object expected";
            let key = Object.keys(message.data);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isString(message.data[key[i]]))
                    return "data: string{k:string} expected";
        }
        if (message.type != null && message.hasOwnProperty("type")) {
            properties._type = 1;
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
                break;
            }
        }
        return null;
    };

    /**
     * Creates a CreateMarkerRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CreateMarkerRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CreateMarkerRequest} CreateMarkerRequest
     */
    CreateMarkerRequest.fromObject = function fromObject(object, long) {
        if (object instanceof $root.CreateMarkerRequest)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.CreateMarkerRequest();
        if (object.anchorRelativePosition != null)
            if (typeof object.anchorRelativePosition === "string")
                $util.base64.decode(object.anchorRelativePosition, message.anchorRelativePosition = $util.newBuffer($util.base64.length(object.anchorRelativePosition)), 0);
            else if (object.anchorRelativePosition.length >= 0)
                message.anchorRelativePosition = object.anchorRelativePosition;
        if (object.focusRelativePosition != null)
            if (typeof object.focusRelativePosition === "string")
                $util.base64.decode(object.focusRelativePosition, message.focusRelativePosition = $util.newBuffer($util.base64.length(object.focusRelativePosition)), 0);
            else if (object.focusRelativePosition.length >= 0)
                message.focusRelativePosition = object.focusRelativePosition;
        if (object.content != null)
            if (typeof object.content === "string")
                $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
            else if (object.content.length >= 0)
                message.content = object.content;
        if (object.data) {
            if (typeof object.data !== "object")
                throw TypeError(".CreateMarkerRequest.data: object expected");
            message.data = {};
            for (let keys = Object.keys(object.data), i = 0; i < keys.length; ++i) {
                if (keys[i] === "__proto__")
                    $util.makeProp(message.data, keys[i]);
                message.data[keys[i]] = String(object.data[keys[i]]);
            }
        }
        switch (object.type) {
        default:
            if (typeof object.type === "number") {
                message.type = object.type;
                break;
            }
            break;
        case "SUGGESTION":
        case 0:
            message.type = 0;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a CreateMarkerRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CreateMarkerRequest
     * @static
     * @param {CreateMarkerRequest} message CreateMarkerRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CreateMarkerRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.objects || options.defaults)
            object.data = {};
        if (options.defaults)
            if (options.bytes === String)
                object.content = "";
            else {
                object.content = [];
                if (options.bytes !== Array)
                    object.content = $util.newBuffer(object.content);
            }
        if (message.anchorRelativePosition != null && message.hasOwnProperty("anchorRelativePosition")) {
            object.anchorRelativePosition = options.bytes === String ? $util.base64.encode(message.anchorRelativePosition, 0, message.anchorRelativePosition.length) : options.bytes === Array ? Array.prototype.slice.call(message.anchorRelativePosition) : message.anchorRelativePosition;
            if (options.oneofs)
                object._anchorRelativePosition = "anchorRelativePosition";
        }
        if (message.focusRelativePosition != null && message.hasOwnProperty("focusRelativePosition")) {
            object.focusRelativePosition = options.bytes === String ? $util.base64.encode(message.focusRelativePosition, 0, message.focusRelativePosition.length) : options.bytes === Array ? Array.prototype.slice.call(message.focusRelativePosition) : message.focusRelativePosition;
            if (options.oneofs)
                object._focusRelativePosition = "focusRelativePosition";
        }
        if (message.content != null && message.hasOwnProperty("content"))
            object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
        let keys2;
        if (message.data && (keys2 = Object.keys(message.data)).length) {
            object.data = {};
            for (let j = 0; j < keys2.length; ++j) {
                if (keys2[j] === "__proto__")
                    $util.makeProp(object.data, keys2[j]);
                object.data[keys2[j]] = message.data[keys2[j]];
            }
        }
        if (message.type != null && message.hasOwnProperty("type")) {
            object.type = options.enums === String ? $root.ContentMarkerType[message.type] === undefined ? message.type : $root.ContentMarkerType[message.type] : message.type;
            if (options.oneofs)
                object._type = "type";
        }
        return object;
    };

    /**
     * Converts this CreateMarkerRequest to JSON.
     * @function toJSON
     * @memberof CreateMarkerRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CreateMarkerRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CreateMarkerRequest
     * @function getTypeUrl
     * @memberof CreateMarkerRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CreateMarkerRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CreateMarkerRequest";
    };

    return CreateMarkerRequest;
})();

export const CreateMarkerReply = $root.CreateMarkerReply = (() => {

    /**
     * Properties of a CreateMarkerReply.
     * @exports ICreateMarkerReply
     * @interface ICreateMarkerReply
     * @property {string|null} [markerId] CreateMarkerReply markerId
     */

    /**
     * Constructs a new CreateMarkerReply.
     * @exports CreateMarkerReply
     * @classdesc Represents a CreateMarkerReply.
     * @implements ICreateMarkerReply
     * @constructor
     * @param {ICreateMarkerReply=} [properties] Properties to set
     */
    function CreateMarkerReply(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CreateMarkerReply markerId.
     * @member {string|null|undefined} markerId
     * @memberof CreateMarkerReply
     * @instance
     */
    CreateMarkerReply.prototype.markerId = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(CreateMarkerReply.prototype, "_markerId", {
        get: $util.oneOfGetter($oneOfFields = ["markerId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new CreateMarkerReply instance using the specified properties.
     * @function create
     * @memberof CreateMarkerReply
     * @static
     * @param {ICreateMarkerReply=} [properties] Properties to set
     * @returns {CreateMarkerReply} CreateMarkerReply instance
     */
    CreateMarkerReply.create = function create(properties) {
        return new CreateMarkerReply(properties);
    };

    /**
     * Encodes the specified CreateMarkerReply message. Does not implicitly {@link CreateMarkerReply.verify|verify} messages.
     * @function encode
     * @memberof CreateMarkerReply
     * @static
     * @param {ICreateMarkerReply} message CreateMarkerReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateMarkerReply.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.markerId != null && Object.hasOwnProperty.call(message, "markerId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.markerId);
        return writer;
    };

    /**
     * Encodes the specified CreateMarkerReply message, length delimited. Does not implicitly {@link CreateMarkerReply.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CreateMarkerReply
     * @static
     * @param {ICreateMarkerReply} message CreateMarkerReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateMarkerReply.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a CreateMarkerReply message from the specified reader or buffer.
     * @function decode
     * @memberof CreateMarkerReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CreateMarkerReply} CreateMarkerReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateMarkerReply.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CreateMarkerReply();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.markerId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CreateMarkerReply message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CreateMarkerReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CreateMarkerReply} CreateMarkerReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateMarkerReply.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CreateMarkerReply message.
     * @function verify
     * @memberof CreateMarkerReply
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CreateMarkerReply.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.markerId != null && message.hasOwnProperty("markerId")) {
            properties._markerId = 1;
            if (!$util.isString(message.markerId))
                return "markerId: string expected";
        }
        return null;
    };

    /**
     * Creates a CreateMarkerReply message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CreateMarkerReply
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CreateMarkerReply} CreateMarkerReply
     */
    CreateMarkerReply.fromObject = function fromObject(object, long) {
        if (object instanceof $root.CreateMarkerReply)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.CreateMarkerReply();
        if (object.markerId != null)
            message.markerId = String(object.markerId);
        return message;
    };

    /**
     * Creates a plain object from a CreateMarkerReply message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CreateMarkerReply
     * @static
     * @param {CreateMarkerReply} message CreateMarkerReply
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CreateMarkerReply.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.markerId != null && message.hasOwnProperty("markerId")) {
            object.markerId = message.markerId;
            if (options.oneofs)
                object._markerId = "markerId";
        }
        return object;
    };

    /**
     * Converts this CreateMarkerReply to JSON.
     * @function toJSON
     * @memberof CreateMarkerReply
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CreateMarkerReply.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CreateMarkerReply
     * @function getTypeUrl
     * @memberof CreateMarkerReply
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CreateMarkerReply.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CreateMarkerReply";
    };

    return CreateMarkerReply;
})();

export const RemoveMarkerRequest = $root.RemoveMarkerRequest = (() => {

    /**
     * Properties of a RemoveMarkerRequest.
     * @exports IRemoveMarkerRequest
     * @interface IRemoveMarkerRequest
     * @property {string|null} [markerId] RemoveMarkerRequest markerId
     */

    /**
     * Constructs a new RemoveMarkerRequest.
     * @exports RemoveMarkerRequest
     * @classdesc Request sent by a client to remove a content marker.
     * @implements IRemoveMarkerRequest
     * @constructor
     * @param {IRemoveMarkerRequest=} [properties] Properties to set
     */
    function RemoveMarkerRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RemoveMarkerRequest markerId.
     * @member {string|null|undefined} markerId
     * @memberof RemoveMarkerRequest
     * @instance
     */
    RemoveMarkerRequest.prototype.markerId = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(RemoveMarkerRequest.prototype, "_markerId", {
        get: $util.oneOfGetter($oneOfFields = ["markerId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new RemoveMarkerRequest instance using the specified properties.
     * @function create
     * @memberof RemoveMarkerRequest
     * @static
     * @param {IRemoveMarkerRequest=} [properties] Properties to set
     * @returns {RemoveMarkerRequest} RemoveMarkerRequest instance
     */
    RemoveMarkerRequest.create = function create(properties) {
        return new RemoveMarkerRequest(properties);
    };

    /**
     * Encodes the specified RemoveMarkerRequest message. Does not implicitly {@link RemoveMarkerRequest.verify|verify} messages.
     * @function encode
     * @memberof RemoveMarkerRequest
     * @static
     * @param {IRemoveMarkerRequest} message RemoveMarkerRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RemoveMarkerRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.markerId != null && Object.hasOwnProperty.call(message, "markerId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.markerId);
        return writer;
    };

    /**
     * Encodes the specified RemoveMarkerRequest message, length delimited. Does not implicitly {@link RemoveMarkerRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RemoveMarkerRequest
     * @static
     * @param {IRemoveMarkerRequest} message RemoveMarkerRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RemoveMarkerRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a RemoveMarkerRequest message from the specified reader or buffer.
     * @function decode
     * @memberof RemoveMarkerRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RemoveMarkerRequest} RemoveMarkerRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RemoveMarkerRequest.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RemoveMarkerRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.markerId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RemoveMarkerRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RemoveMarkerRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RemoveMarkerRequest} RemoveMarkerRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RemoveMarkerRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RemoveMarkerRequest message.
     * @function verify
     * @memberof RemoveMarkerRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RemoveMarkerRequest.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.markerId != null && message.hasOwnProperty("markerId")) {
            properties._markerId = 1;
            if (!$util.isString(message.markerId))
                return "markerId: string expected";
        }
        return null;
    };

    /**
     * Creates a RemoveMarkerRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RemoveMarkerRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RemoveMarkerRequest} RemoveMarkerRequest
     */
    RemoveMarkerRequest.fromObject = function fromObject(object, long) {
        if (object instanceof $root.RemoveMarkerRequest)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.RemoveMarkerRequest();
        if (object.markerId != null)
            message.markerId = String(object.markerId);
        return message;
    };

    /**
     * Creates a plain object from a RemoveMarkerRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RemoveMarkerRequest
     * @static
     * @param {RemoveMarkerRequest} message RemoveMarkerRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RemoveMarkerRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.markerId != null && message.hasOwnProperty("markerId")) {
            object.markerId = message.markerId;
            if (options.oneofs)
                object._markerId = "markerId";
        }
        return object;
    };

    /**
     * Converts this RemoveMarkerRequest to JSON.
     * @function toJSON
     * @memberof RemoveMarkerRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RemoveMarkerRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RemoveMarkerRequest
     * @function getTypeUrl
     * @memberof RemoveMarkerRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RemoveMarkerRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RemoveMarkerRequest";
    };

    return RemoveMarkerRequest;
})();

export const RemoveMarkerReply = $root.RemoveMarkerReply = (() => {

    /**
     * Properties of a RemoveMarkerReply.
     * @exports IRemoveMarkerReply
     * @interface IRemoveMarkerReply
     */

    /**
     * Constructs a new RemoveMarkerReply.
     * @exports RemoveMarkerReply
     * @classdesc Represents a RemoveMarkerReply.
     * @implements IRemoveMarkerReply
     * @constructor
     * @param {IRemoveMarkerReply=} [properties] Properties to set
     */
    function RemoveMarkerReply(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new RemoveMarkerReply instance using the specified properties.
     * @function create
     * @memberof RemoveMarkerReply
     * @static
     * @param {IRemoveMarkerReply=} [properties] Properties to set
     * @returns {RemoveMarkerReply} RemoveMarkerReply instance
     */
    RemoveMarkerReply.create = function create(properties) {
        return new RemoveMarkerReply(properties);
    };

    /**
     * Encodes the specified RemoveMarkerReply message. Does not implicitly {@link RemoveMarkerReply.verify|verify} messages.
     * @function encode
     * @memberof RemoveMarkerReply
     * @static
     * @param {IRemoveMarkerReply} message RemoveMarkerReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RemoveMarkerReply.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified RemoveMarkerReply message, length delimited. Does not implicitly {@link RemoveMarkerReply.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RemoveMarkerReply
     * @static
     * @param {IRemoveMarkerReply} message RemoveMarkerReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RemoveMarkerReply.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a RemoveMarkerReply message from the specified reader or buffer.
     * @function decode
     * @memberof RemoveMarkerReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RemoveMarkerReply} RemoveMarkerReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RemoveMarkerReply.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RemoveMarkerReply();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RemoveMarkerReply message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RemoveMarkerReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RemoveMarkerReply} RemoveMarkerReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RemoveMarkerReply.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RemoveMarkerReply message.
     * @function verify
     * @memberof RemoveMarkerReply
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RemoveMarkerReply.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        return null;
    };

    /**
     * Creates a RemoveMarkerReply message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RemoveMarkerReply
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RemoveMarkerReply} RemoveMarkerReply
     */
    RemoveMarkerReply.fromObject = function fromObject(object, long) {
        if (object instanceof $root.RemoveMarkerReply)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        return new $root.RemoveMarkerReply();
    };

    /**
     * Creates a plain object from a RemoveMarkerReply message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RemoveMarkerReply
     * @static
     * @param {RemoveMarkerReply} message RemoveMarkerReply
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RemoveMarkerReply.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this RemoveMarkerReply to JSON.
     * @function toJSON
     * @memberof RemoveMarkerReply
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RemoveMarkerReply.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RemoveMarkerReply
     * @function getTypeUrl
     * @memberof RemoveMarkerReply
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RemoveMarkerReply.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RemoveMarkerReply";
    };

    return RemoveMarkerReply;
})();

export const DuplicatePageRequest = $root.DuplicatePageRequest = (() => {

    /**
     * Properties of a DuplicatePageRequest.
     * @exports IDuplicatePageRequest
     * @interface IDuplicatePageRequest
     * @property {string|null} [originalPageId] DuplicatePageRequest originalPageId
     * @property {string|null} [newPageId] DuplicatePageRequest newPageId
     * @property {string|null} [parentPageId] DuplicatePageRequest parentPageId
     */

    /**
     * Constructs a new DuplicatePageRequest.
     * @exports DuplicatePageRequest
     * @classdesc Request sent by a client to duplicate a page within the current branch.
     * @implements IDuplicatePageRequest
     * @constructor
     * @param {IDuplicatePageRequest=} [properties] Properties to set
     */
    function DuplicatePageRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DuplicatePageRequest originalPageId.
     * @member {string} originalPageId
     * @memberof DuplicatePageRequest
     * @instance
     */
    DuplicatePageRequest.prototype.originalPageId = "";

    /**
     * DuplicatePageRequest newPageId.
     * @member {string|null|undefined} newPageId
     * @memberof DuplicatePageRequest
     * @instance
     */
    DuplicatePageRequest.prototype.newPageId = null;

    /**
     * DuplicatePageRequest parentPageId.
     * @member {string|null|undefined} parentPageId
     * @memberof DuplicatePageRequest
     * @instance
     */
    DuplicatePageRequest.prototype.parentPageId = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(DuplicatePageRequest.prototype, "_newPageId", {
        get: $util.oneOfGetter($oneOfFields = ["newPageId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(DuplicatePageRequest.prototype, "_parentPageId", {
        get: $util.oneOfGetter($oneOfFields = ["parentPageId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new DuplicatePageRequest instance using the specified properties.
     * @function create
     * @memberof DuplicatePageRequest
     * @static
     * @param {IDuplicatePageRequest=} [properties] Properties to set
     * @returns {DuplicatePageRequest} DuplicatePageRequest instance
     */
    DuplicatePageRequest.create = function create(properties) {
        return new DuplicatePageRequest(properties);
    };

    /**
     * Encodes the specified DuplicatePageRequest message. Does not implicitly {@link DuplicatePageRequest.verify|verify} messages.
     * @function encode
     * @memberof DuplicatePageRequest
     * @static
     * @param {IDuplicatePageRequest} message DuplicatePageRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DuplicatePageRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.originalPageId != null && Object.hasOwnProperty.call(message, "originalPageId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.originalPageId);
        if (message.newPageId != null && Object.hasOwnProperty.call(message, "newPageId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.newPageId);
        if (message.parentPageId != null && Object.hasOwnProperty.call(message, "parentPageId"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.parentPageId);
        return writer;
    };

    /**
     * Encodes the specified DuplicatePageRequest message, length delimited. Does not implicitly {@link DuplicatePageRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DuplicatePageRequest
     * @static
     * @param {IDuplicatePageRequest} message DuplicatePageRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DuplicatePageRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a DuplicatePageRequest message from the specified reader or buffer.
     * @function decode
     * @memberof DuplicatePageRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DuplicatePageRequest} DuplicatePageRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DuplicatePageRequest.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DuplicatePageRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.originalPageId = reader.string();
                    break;
                }
            case 2: {
                    message.newPageId = reader.string();
                    break;
                }
            case 3: {
                    message.parentPageId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DuplicatePageRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DuplicatePageRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DuplicatePageRequest} DuplicatePageRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DuplicatePageRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DuplicatePageRequest message.
     * @function verify
     * @memberof DuplicatePageRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DuplicatePageRequest.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.originalPageId != null && message.hasOwnProperty("originalPageId"))
            if (!$util.isString(message.originalPageId))
                return "originalPageId: string expected";
        if (message.newPageId != null && message.hasOwnProperty("newPageId")) {
            properties._newPageId = 1;
            if (!$util.isString(message.newPageId))
                return "newPageId: string expected";
        }
        if (message.parentPageId != null && message.hasOwnProperty("parentPageId")) {
            properties._parentPageId = 1;
            if (!$util.isString(message.parentPageId))
                return "parentPageId: string expected";
        }
        return null;
    };

    /**
     * Creates a DuplicatePageRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DuplicatePageRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DuplicatePageRequest} DuplicatePageRequest
     */
    DuplicatePageRequest.fromObject = function fromObject(object, long) {
        if (object instanceof $root.DuplicatePageRequest)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.DuplicatePageRequest();
        if (object.originalPageId != null)
            message.originalPageId = String(object.originalPageId);
        if (object.newPageId != null)
            message.newPageId = String(object.newPageId);
        if (object.parentPageId != null)
            message.parentPageId = String(object.parentPageId);
        return message;
    };

    /**
     * Creates a plain object from a DuplicatePageRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DuplicatePageRequest
     * @static
     * @param {DuplicatePageRequest} message DuplicatePageRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DuplicatePageRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.originalPageId = "";
        if (message.originalPageId != null && message.hasOwnProperty("originalPageId"))
            object.originalPageId = message.originalPageId;
        if (message.newPageId != null && message.hasOwnProperty("newPageId")) {
            object.newPageId = message.newPageId;
            if (options.oneofs)
                object._newPageId = "newPageId";
        }
        if (message.parentPageId != null && message.hasOwnProperty("parentPageId")) {
            object.parentPageId = message.parentPageId;
            if (options.oneofs)
                object._parentPageId = "parentPageId";
        }
        return object;
    };

    /**
     * Converts this DuplicatePageRequest to JSON.
     * @function toJSON
     * @memberof DuplicatePageRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DuplicatePageRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DuplicatePageRequest
     * @function getTypeUrl
     * @memberof DuplicatePageRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DuplicatePageRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DuplicatePageRequest";
    };

    return DuplicatePageRequest;
})();

export const DuplicatePageReply = $root.DuplicatePageReply = (() => {

    /**
     * Properties of a DuplicatePageReply.
     * @exports IDuplicatePageReply
     * @interface IDuplicatePageReply
     * @property {string|null} [pageId] DuplicatePageReply pageId
     */

    /**
     * Constructs a new DuplicatePageReply.
     * @exports DuplicatePageReply
     * @classdesc Represents a DuplicatePageReply.
     * @implements IDuplicatePageReply
     * @constructor
     * @param {IDuplicatePageReply=} [properties] Properties to set
     */
    function DuplicatePageReply(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DuplicatePageReply pageId.
     * @member {string|null|undefined} pageId
     * @memberof DuplicatePageReply
     * @instance
     */
    DuplicatePageReply.prototype.pageId = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(DuplicatePageReply.prototype, "_pageId", {
        get: $util.oneOfGetter($oneOfFields = ["pageId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new DuplicatePageReply instance using the specified properties.
     * @function create
     * @memberof DuplicatePageReply
     * @static
     * @param {IDuplicatePageReply=} [properties] Properties to set
     * @returns {DuplicatePageReply} DuplicatePageReply instance
     */
    DuplicatePageReply.create = function create(properties) {
        return new DuplicatePageReply(properties);
    };

    /**
     * Encodes the specified DuplicatePageReply message. Does not implicitly {@link DuplicatePageReply.verify|verify} messages.
     * @function encode
     * @memberof DuplicatePageReply
     * @static
     * @param {IDuplicatePageReply} message DuplicatePageReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DuplicatePageReply.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.pageId != null && Object.hasOwnProperty.call(message, "pageId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.pageId);
        return writer;
    };

    /**
     * Encodes the specified DuplicatePageReply message, length delimited. Does not implicitly {@link DuplicatePageReply.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DuplicatePageReply
     * @static
     * @param {IDuplicatePageReply} message DuplicatePageReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DuplicatePageReply.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a DuplicatePageReply message from the specified reader or buffer.
     * @function decode
     * @memberof DuplicatePageReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DuplicatePageReply} DuplicatePageReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DuplicatePageReply.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DuplicatePageReply();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.pageId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DuplicatePageReply message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DuplicatePageReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DuplicatePageReply} DuplicatePageReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DuplicatePageReply.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DuplicatePageReply message.
     * @function verify
     * @memberof DuplicatePageReply
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DuplicatePageReply.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.pageId != null && message.hasOwnProperty("pageId")) {
            properties._pageId = 1;
            if (!$util.isString(message.pageId))
                return "pageId: string expected";
        }
        return null;
    };

    /**
     * Creates a DuplicatePageReply message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DuplicatePageReply
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DuplicatePageReply} DuplicatePageReply
     */
    DuplicatePageReply.fromObject = function fromObject(object, long) {
        if (object instanceof $root.DuplicatePageReply)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.DuplicatePageReply();
        if (object.pageId != null)
            message.pageId = String(object.pageId);
        return message;
    };

    /**
     * Creates a plain object from a DuplicatePageReply message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DuplicatePageReply
     * @static
     * @param {DuplicatePageReply} message DuplicatePageReply
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DuplicatePageReply.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.pageId != null && message.hasOwnProperty("pageId")) {
            object.pageId = message.pageId;
            if (options.oneofs)
                object._pageId = "pageId";
        }
        return object;
    };

    /**
     * Converts this DuplicatePageReply to JSON.
     * @function toJSON
     * @memberof DuplicatePageReply
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DuplicatePageReply.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DuplicatePageReply
     * @function getTypeUrl
     * @memberof DuplicatePageReply
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DuplicatePageReply.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DuplicatePageReply";
    };

    return DuplicatePageReply;
})();

export const SubscribeRequest = $root.SubscribeRequest = (() => {

    /**
     * Properties of a SubscribeRequest.
     * @exports ISubscribeRequest
     * @interface ISubscribeRequest
     * @property {number|null} [id] SubscribeRequest id
     * @property {IResourceIdentifier|null} [identifier] SubscribeRequest identifier
     */

    /**
     * Constructs a new SubscribeRequest.
     * @exports SubscribeRequest
     * @classdesc Represents a SubscribeRequest.
     * @implements ISubscribeRequest
     * @constructor
     * @param {ISubscribeRequest=} [properties] Properties to set
     */
    function SubscribeRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SubscribeRequest id.
     * @member {number|null|undefined} id
     * @memberof SubscribeRequest
     * @instance
     */
    SubscribeRequest.prototype.id = null;

    /**
     * SubscribeRequest identifier.
     * @member {IResourceIdentifier|null|undefined} identifier
     * @memberof SubscribeRequest
     * @instance
     */
    SubscribeRequest.prototype.identifier = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(SubscribeRequest.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new SubscribeRequest instance using the specified properties.
     * @function create
     * @memberof SubscribeRequest
     * @static
     * @param {ISubscribeRequest=} [properties] Properties to set
     * @returns {SubscribeRequest} SubscribeRequest instance
     */
    SubscribeRequest.create = function create(properties) {
        return new SubscribeRequest(properties);
    };

    /**
     * Encodes the specified SubscribeRequest message. Does not implicitly {@link SubscribeRequest.verify|verify} messages.
     * @function encode
     * @memberof SubscribeRequest
     * @static
     * @param {ISubscribeRequest} message SubscribeRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubscribeRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        if (message.identifier != null && Object.hasOwnProperty.call(message, "identifier"))
            $root.ResourceIdentifier.encode(message.identifier, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified SubscribeRequest message, length delimited. Does not implicitly {@link SubscribeRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SubscribeRequest
     * @static
     * @param {ISubscribeRequest} message SubscribeRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubscribeRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a SubscribeRequest message from the specified reader or buffer.
     * @function decode
     * @memberof SubscribeRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SubscribeRequest} SubscribeRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubscribeRequest.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SubscribeRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    message.identifier = $root.ResourceIdentifier.decode(reader, reader.uint32(), undefined, long + 1);
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SubscribeRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SubscribeRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SubscribeRequest} SubscribeRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubscribeRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SubscribeRequest message.
     * @function verify
     * @memberof SubscribeRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SubscribeRequest.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            properties._id = 1;
            if (!$util.isInteger(message.id))
                return "id: integer expected";
        }
        if (message.identifier != null && message.hasOwnProperty("identifier")) {
            let error = $root.ResourceIdentifier.verify(message.identifier, long + 1);
            if (error)
                return "identifier." + error;
        }
        return null;
    };

    /**
     * Creates a SubscribeRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SubscribeRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SubscribeRequest} SubscribeRequest
     */
    SubscribeRequest.fromObject = function fromObject(object, long) {
        if (object instanceof $root.SubscribeRequest)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.SubscribeRequest();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.identifier != null) {
            if (typeof object.identifier !== "object")
                throw TypeError(".SubscribeRequest.identifier: object expected");
            message.identifier = $root.ResourceIdentifier.fromObject(object.identifier, long + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from a SubscribeRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SubscribeRequest
     * @static
     * @param {SubscribeRequest} message SubscribeRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SubscribeRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.identifier = null;
        if (message.id != null && message.hasOwnProperty("id")) {
            object.id = message.id;
            if (options.oneofs)
                object._id = "id";
        }
        if (message.identifier != null && message.hasOwnProperty("identifier"))
            object.identifier = $root.ResourceIdentifier.toObject(message.identifier, options);
        return object;
    };

    /**
     * Converts this SubscribeRequest to JSON.
     * @function toJSON
     * @memberof SubscribeRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SubscribeRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for SubscribeRequest
     * @function getTypeUrl
     * @memberof SubscribeRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    SubscribeRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SubscribeRequest";
    };

    return SubscribeRequest;
})();

export const SubscribeReply = $root.SubscribeReply = (() => {

    /**
     * Properties of a SubscribeReply.
     * @exports ISubscribeReply
     * @interface ISubscribeReply
     * @property {boolean|null} [success] SubscribeReply success
     */

    /**
     * Constructs a new SubscribeReply.
     * @exports SubscribeReply
     * @classdesc Represents a SubscribeReply.
     * @implements ISubscribeReply
     * @constructor
     * @param {ISubscribeReply=} [properties] Properties to set
     */
    function SubscribeReply(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SubscribeReply success.
     * @member {boolean} success
     * @memberof SubscribeReply
     * @instance
     */
    SubscribeReply.prototype.success = false;

    /**
     * Creates a new SubscribeReply instance using the specified properties.
     * @function create
     * @memberof SubscribeReply
     * @static
     * @param {ISubscribeReply=} [properties] Properties to set
     * @returns {SubscribeReply} SubscribeReply instance
     */
    SubscribeReply.create = function create(properties) {
        return new SubscribeReply(properties);
    };

    /**
     * Encodes the specified SubscribeReply message. Does not implicitly {@link SubscribeReply.verify|verify} messages.
     * @function encode
     * @memberof SubscribeReply
     * @static
     * @param {ISubscribeReply} message SubscribeReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubscribeReply.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.success != null && Object.hasOwnProperty.call(message, "success"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.success);
        return writer;
    };

    /**
     * Encodes the specified SubscribeReply message, length delimited. Does not implicitly {@link SubscribeReply.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SubscribeReply
     * @static
     * @param {ISubscribeReply} message SubscribeReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubscribeReply.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a SubscribeReply message from the specified reader or buffer.
     * @function decode
     * @memberof SubscribeReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SubscribeReply} SubscribeReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubscribeReply.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SubscribeReply();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.success = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SubscribeReply message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SubscribeReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SubscribeReply} SubscribeReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubscribeReply.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SubscribeReply message.
     * @function verify
     * @memberof SubscribeReply
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SubscribeReply.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        if (message.success != null && message.hasOwnProperty("success"))
            if (typeof message.success !== "boolean")
                return "success: boolean expected";
        return null;
    };

    /**
     * Creates a SubscribeReply message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SubscribeReply
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SubscribeReply} SubscribeReply
     */
    SubscribeReply.fromObject = function fromObject(object, long) {
        if (object instanceof $root.SubscribeReply)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.SubscribeReply();
        if (object.success != null)
            message.success = Boolean(object.success);
        return message;
    };

    /**
     * Creates a plain object from a SubscribeReply message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SubscribeReply
     * @static
     * @param {SubscribeReply} message SubscribeReply
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SubscribeReply.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.success = false;
        if (message.success != null && message.hasOwnProperty("success"))
            object.success = message.success;
        return object;
    };

    /**
     * Converts this SubscribeReply to JSON.
     * @function toJSON
     * @memberof SubscribeReply
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SubscribeReply.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for SubscribeReply
     * @function getTypeUrl
     * @memberof SubscribeReply
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    SubscribeReply.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SubscribeReply";
    };

    return SubscribeReply;
})();

export const UnsubscribeRequest = $root.UnsubscribeRequest = (() => {

    /**
     * Properties of an UnsubscribeRequest.
     * @exports IUnsubscribeRequest
     * @interface IUnsubscribeRequest
     */

    /**
     * Constructs a new UnsubscribeRequest.
     * @exports UnsubscribeRequest
     * @classdesc Represents an UnsubscribeRequest.
     * @implements IUnsubscribeRequest
     * @constructor
     * @param {IUnsubscribeRequest=} [properties] Properties to set
     */
    function UnsubscribeRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new UnsubscribeRequest instance using the specified properties.
     * @function create
     * @memberof UnsubscribeRequest
     * @static
     * @param {IUnsubscribeRequest=} [properties] Properties to set
     * @returns {UnsubscribeRequest} UnsubscribeRequest instance
     */
    UnsubscribeRequest.create = function create(properties) {
        return new UnsubscribeRequest(properties);
    };

    /**
     * Encodes the specified UnsubscribeRequest message. Does not implicitly {@link UnsubscribeRequest.verify|verify} messages.
     * @function encode
     * @memberof UnsubscribeRequest
     * @static
     * @param {IUnsubscribeRequest} message UnsubscribeRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnsubscribeRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified UnsubscribeRequest message, length delimited. Does not implicitly {@link UnsubscribeRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UnsubscribeRequest
     * @static
     * @param {IUnsubscribeRequest} message UnsubscribeRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnsubscribeRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes an UnsubscribeRequest message from the specified reader or buffer.
     * @function decode
     * @memberof UnsubscribeRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UnsubscribeRequest} UnsubscribeRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnsubscribeRequest.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnsubscribeRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UnsubscribeRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UnsubscribeRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UnsubscribeRequest} UnsubscribeRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnsubscribeRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UnsubscribeRequest message.
     * @function verify
     * @memberof UnsubscribeRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UnsubscribeRequest.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        return null;
    };

    /**
     * Creates an UnsubscribeRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UnsubscribeRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UnsubscribeRequest} UnsubscribeRequest
     */
    UnsubscribeRequest.fromObject = function fromObject(object, long) {
        if (object instanceof $root.UnsubscribeRequest)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        return new $root.UnsubscribeRequest();
    };

    /**
     * Creates a plain object from an UnsubscribeRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UnsubscribeRequest
     * @static
     * @param {UnsubscribeRequest} message UnsubscribeRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnsubscribeRequest.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this UnsubscribeRequest to JSON.
     * @function toJSON
     * @memberof UnsubscribeRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnsubscribeRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UnsubscribeRequest
     * @function getTypeUrl
     * @memberof UnsubscribeRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UnsubscribeRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UnsubscribeRequest";
    };

    return UnsubscribeRequest;
})();

export const UnsubscribeReply = $root.UnsubscribeReply = (() => {

    /**
     * Properties of an UnsubscribeReply.
     * @exports IUnsubscribeReply
     * @interface IUnsubscribeReply
     * @property {boolean|null} [success] UnsubscribeReply success
     */

    /**
     * Constructs a new UnsubscribeReply.
     * @exports UnsubscribeReply
     * @classdesc Represents an UnsubscribeReply.
     * @implements IUnsubscribeReply
     * @constructor
     * @param {IUnsubscribeReply=} [properties] Properties to set
     */
    function UnsubscribeReply(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UnsubscribeReply success.
     * @member {boolean} success
     * @memberof UnsubscribeReply
     * @instance
     */
    UnsubscribeReply.prototype.success = false;

    /**
     * Creates a new UnsubscribeReply instance using the specified properties.
     * @function create
     * @memberof UnsubscribeReply
     * @static
     * @param {IUnsubscribeReply=} [properties] Properties to set
     * @returns {UnsubscribeReply} UnsubscribeReply instance
     */
    UnsubscribeReply.create = function create(properties) {
        return new UnsubscribeReply(properties);
    };

    /**
     * Encodes the specified UnsubscribeReply message. Does not implicitly {@link UnsubscribeReply.verify|verify} messages.
     * @function encode
     * @memberof UnsubscribeReply
     * @static
     * @param {IUnsubscribeReply} message UnsubscribeReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnsubscribeReply.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.success != null && Object.hasOwnProperty.call(message, "success"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.success);
        return writer;
    };

    /**
     * Encodes the specified UnsubscribeReply message, length delimited. Does not implicitly {@link UnsubscribeReply.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UnsubscribeReply
     * @static
     * @param {IUnsubscribeReply} message UnsubscribeReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnsubscribeReply.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes an UnsubscribeReply message from the specified reader or buffer.
     * @function decode
     * @memberof UnsubscribeReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UnsubscribeReply} UnsubscribeReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnsubscribeReply.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnsubscribeReply();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.success = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UnsubscribeReply message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UnsubscribeReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UnsubscribeReply} UnsubscribeReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnsubscribeReply.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UnsubscribeReply message.
     * @function verify
     * @memberof UnsubscribeReply
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UnsubscribeReply.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        if (message.success != null && message.hasOwnProperty("success"))
            if (typeof message.success !== "boolean")
                return "success: boolean expected";
        return null;
    };

    /**
     * Creates an UnsubscribeReply message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UnsubscribeReply
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UnsubscribeReply} UnsubscribeReply
     */
    UnsubscribeReply.fromObject = function fromObject(object, long) {
        if (object instanceof $root.UnsubscribeReply)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.UnsubscribeReply();
        if (object.success != null)
            message.success = Boolean(object.success);
        return message;
    };

    /**
     * Creates a plain object from an UnsubscribeReply message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UnsubscribeReply
     * @static
     * @param {UnsubscribeReply} message UnsubscribeReply
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnsubscribeReply.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.success = false;
        if (message.success != null && message.hasOwnProperty("success"))
            object.success = message.success;
        return object;
    };

    /**
     * Converts this UnsubscribeReply to JSON.
     * @function toJSON
     * @memberof UnsubscribeReply
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnsubscribeReply.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UnsubscribeReply
     * @function getTypeUrl
     * @memberof UnsubscribeReply
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UnsubscribeReply.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UnsubscribeReply";
    };

    return UnsubscribeReply;
})();

export const ReconnectRequest = $root.ReconnectRequest = (() => {

    /**
     * Properties of a ReconnectRequest.
     * @exports IReconnectRequest
     * @interface IReconnectRequest
     * @property {number|null} [subscriptionId] ReconnectRequest subscriptionId
     */

    /**
     * Constructs a new ReconnectRequest.
     * @exports ReconnectRequest
     * @classdesc Represents a ReconnectRequest.
     * @implements IReconnectRequest
     * @constructor
     * @param {IReconnectRequest=} [properties] Properties to set
     */
    function ReconnectRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ReconnectRequest subscriptionId.
     * @member {number|null|undefined} subscriptionId
     * @memberof ReconnectRequest
     * @instance
     */
    ReconnectRequest.prototype.subscriptionId = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ReconnectRequest.prototype, "_subscriptionId", {
        get: $util.oneOfGetter($oneOfFields = ["subscriptionId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new ReconnectRequest instance using the specified properties.
     * @function create
     * @memberof ReconnectRequest
     * @static
     * @param {IReconnectRequest=} [properties] Properties to set
     * @returns {ReconnectRequest} ReconnectRequest instance
     */
    ReconnectRequest.create = function create(properties) {
        return new ReconnectRequest(properties);
    };

    /**
     * Encodes the specified ReconnectRequest message. Does not implicitly {@link ReconnectRequest.verify|verify} messages.
     * @function encode
     * @memberof ReconnectRequest
     * @static
     * @param {IReconnectRequest} message ReconnectRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReconnectRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.subscriptionId);
        return writer;
    };

    /**
     * Encodes the specified ReconnectRequest message, length delimited. Does not implicitly {@link ReconnectRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ReconnectRequest
     * @static
     * @param {IReconnectRequest} message ReconnectRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReconnectRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a ReconnectRequest message from the specified reader or buffer.
     * @function decode
     * @memberof ReconnectRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ReconnectRequest} ReconnectRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReconnectRequest.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReconnectRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.subscriptionId = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ReconnectRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ReconnectRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ReconnectRequest} ReconnectRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReconnectRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ReconnectRequest message.
     * @function verify
     * @memberof ReconnectRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ReconnectRequest.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            properties._subscriptionId = 1;
            if (!$util.isInteger(message.subscriptionId))
                return "subscriptionId: integer expected";
        }
        return null;
    };

    /**
     * Creates a ReconnectRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ReconnectRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ReconnectRequest} ReconnectRequest
     */
    ReconnectRequest.fromObject = function fromObject(object, long) {
        if (object instanceof $root.ReconnectRequest)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.ReconnectRequest();
        if (object.subscriptionId != null)
            message.subscriptionId = object.subscriptionId | 0;
        return message;
    };

    /**
     * Creates a plain object from a ReconnectRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ReconnectRequest
     * @static
     * @param {ReconnectRequest} message ReconnectRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ReconnectRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId")) {
            object.subscriptionId = message.subscriptionId;
            if (options.oneofs)
                object._subscriptionId = "subscriptionId";
        }
        return object;
    };

    /**
     * Converts this ReconnectRequest to JSON.
     * @function toJSON
     * @memberof ReconnectRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ReconnectRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ReconnectRequest
     * @function getTypeUrl
     * @memberof ReconnectRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ReconnectRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ReconnectRequest";
    };

    return ReconnectRequest;
})();

export const ReconnectReply = $root.ReconnectReply = (() => {

    /**
     * Properties of a ReconnectReply.
     * @exports IReconnectReply
     * @interface IReconnectReply
     */

    /**
     * Constructs a new ReconnectReply.
     * @exports ReconnectReply
     * @classdesc Represents a ReconnectReply.
     * @implements IReconnectReply
     * @constructor
     * @param {IReconnectReply=} [properties] Properties to set
     */
    function ReconnectReply(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new ReconnectReply instance using the specified properties.
     * @function create
     * @memberof ReconnectReply
     * @static
     * @param {IReconnectReply=} [properties] Properties to set
     * @returns {ReconnectReply} ReconnectReply instance
     */
    ReconnectReply.create = function create(properties) {
        return new ReconnectReply(properties);
    };

    /**
     * Encodes the specified ReconnectReply message. Does not implicitly {@link ReconnectReply.verify|verify} messages.
     * @function encode
     * @memberof ReconnectReply
     * @static
     * @param {IReconnectReply} message ReconnectReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReconnectReply.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified ReconnectReply message, length delimited. Does not implicitly {@link ReconnectReply.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ReconnectReply
     * @static
     * @param {IReconnectReply} message ReconnectReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReconnectReply.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a ReconnectReply message from the specified reader or buffer.
     * @function decode
     * @memberof ReconnectReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ReconnectReply} ReconnectReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReconnectReply.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReconnectReply();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ReconnectReply message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ReconnectReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ReconnectReply} ReconnectReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReconnectReply.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ReconnectReply message.
     * @function verify
     * @memberof ReconnectReply
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ReconnectReply.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        return null;
    };

    /**
     * Creates a ReconnectReply message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ReconnectReply
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ReconnectReply} ReconnectReply
     */
    ReconnectReply.fromObject = function fromObject(object, long) {
        if (object instanceof $root.ReconnectReply)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        return new $root.ReconnectReply();
    };

    /**
     * Creates a plain object from a ReconnectReply message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ReconnectReply
     * @static
     * @param {ReconnectReply} message ReconnectReply
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ReconnectReply.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this ReconnectReply to JSON.
     * @function toJSON
     * @memberof ReconnectReply
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ReconnectReply.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ReconnectReply
     * @function getTypeUrl
     * @memberof ReconnectReply
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ReconnectReply.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ReconnectReply";
    };

    return ReconnectReply;
})();

export const ContentMarker = $root.ContentMarker = (() => {

    /**
     * Properties of a ContentMarker.
     * @exports IContentMarker
     * @interface IContentMarker
     * @property {string|null} [markerId] ContentMarker markerId
     * @property {ContentMarkerType|null} [type] ContentMarker type
     * @property {string|null} [author] ContentMarker author
     * @property {Uint8Array|null} [anchorRelativePosition] ContentMarker anchorRelativePosition
     * @property {Uint8Array|null} [focusRelativePosition] ContentMarker focusRelativePosition
     * @property {Uint8Array|null} [content] ContentMarker content
     * @property {Object.<string,string>|null} [data] ContentMarker data
     */

    /**
     * Constructs a new ContentMarker.
     * @exports ContentMarker
     * @classdesc Content marker
     * @implements IContentMarker
     * @constructor
     * @param {IContentMarker=} [properties] Properties to set
     */
    function ContentMarker(properties) {
        this.data = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ContentMarker markerId.
     * @member {string|null|undefined} markerId
     * @memberof ContentMarker
     * @instance
     */
    ContentMarker.prototype.markerId = null;

    /**
     * ContentMarker type.
     * @member {ContentMarkerType|null|undefined} type
     * @memberof ContentMarker
     * @instance
     */
    ContentMarker.prototype.type = null;

    /**
     * ContentMarker author.
     * @member {string|null|undefined} author
     * @memberof ContentMarker
     * @instance
     */
    ContentMarker.prototype.author = null;

    /**
     * ContentMarker anchorRelativePosition.
     * @member {Uint8Array|null|undefined} anchorRelativePosition
     * @memberof ContentMarker
     * @instance
     */
    ContentMarker.prototype.anchorRelativePosition = null;

    /**
     * ContentMarker focusRelativePosition.
     * @member {Uint8Array|null|undefined} focusRelativePosition
     * @memberof ContentMarker
     * @instance
     */
    ContentMarker.prototype.focusRelativePosition = null;

    /**
     * ContentMarker content.
     * @member {Uint8Array} content
     * @memberof ContentMarker
     * @instance
     */
    ContentMarker.prototype.content = $util.newBuffer([]);

    /**
     * ContentMarker data.
     * @member {Object.<string,string>} data
     * @memberof ContentMarker
     * @instance
     */
    ContentMarker.prototype.data = $util.emptyObject;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ContentMarker.prototype, "_markerId", {
        get: $util.oneOfGetter($oneOfFields = ["markerId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ContentMarker.prototype, "_type", {
        get: $util.oneOfGetter($oneOfFields = ["type"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ContentMarker.prototype, "_author", {
        get: $util.oneOfGetter($oneOfFields = ["author"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ContentMarker.prototype, "_anchorRelativePosition", {
        get: $util.oneOfGetter($oneOfFields = ["anchorRelativePosition"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ContentMarker.prototype, "_focusRelativePosition", {
        get: $util.oneOfGetter($oneOfFields = ["focusRelativePosition"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new ContentMarker instance using the specified properties.
     * @function create
     * @memberof ContentMarker
     * @static
     * @param {IContentMarker=} [properties] Properties to set
     * @returns {ContentMarker} ContentMarker instance
     */
    ContentMarker.create = function create(properties) {
        return new ContentMarker(properties);
    };

    /**
     * Encodes the specified ContentMarker message. Does not implicitly {@link ContentMarker.verify|verify} messages.
     * @function encode
     * @memberof ContentMarker
     * @static
     * @param {IContentMarker} message ContentMarker message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContentMarker.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.markerId != null && Object.hasOwnProperty.call(message, "markerId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.markerId);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
        if (message.author != null && Object.hasOwnProperty.call(message, "author"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.author);
        if (message.anchorRelativePosition != null && Object.hasOwnProperty.call(message, "anchorRelativePosition"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.anchorRelativePosition);
        if (message.focusRelativePosition != null && Object.hasOwnProperty.call(message, "focusRelativePosition"))
            writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.focusRelativePosition);
        if (message.content != null && Object.hasOwnProperty.call(message, "content"))
            writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.content);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            for (let keys = Object.keys(message.data), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 7, wireType 2 =*/58).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.data[keys[i]]).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ContentMarker message, length delimited. Does not implicitly {@link ContentMarker.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ContentMarker
     * @static
     * @param {IContentMarker} message ContentMarker message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContentMarker.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a ContentMarker message from the specified reader or buffer.
     * @function decode
     * @memberof ContentMarker
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ContentMarker} ContentMarker
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContentMarker.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ContentMarker(), key, value;
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.markerId = reader.string();
                    break;
                }
            case 2: {
                    message.type = reader.int32();
                    break;
                }
            case 3: {
                    message.author = reader.string();
                    break;
                }
            case 4: {
                    message.anchorRelativePosition = reader.bytes();
                    break;
                }
            case 5: {
                    message.focusRelativePosition = reader.bytes();
                    break;
                }
            case 6: {
                    message.content = reader.bytes();
                    break;
                }
            case 7: {
                    if (message.data === $util.emptyObject)
                        message.data = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = "";
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.string();
                            break;
                        default:
                            reader.skipType(tag2 & 7, long);
                            break;
                        }
                    }
                    if (key === "__proto__")
                        $util.makeProp(message.data, key);
                    message.data[key] = value;
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ContentMarker message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ContentMarker
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ContentMarker} ContentMarker
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContentMarker.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ContentMarker message.
     * @function verify
     * @memberof ContentMarker
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ContentMarker.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.markerId != null && message.hasOwnProperty("markerId")) {
            properties._markerId = 1;
            if (!$util.isString(message.markerId))
                return "markerId: string expected";
        }
        if (message.type != null && message.hasOwnProperty("type")) {
            properties._type = 1;
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
                break;
            }
        }
        if (message.author != null && message.hasOwnProperty("author")) {
            properties._author = 1;
            if (!$util.isString(message.author))
                return "author: string expected";
        }
        if (message.anchorRelativePosition != null && message.hasOwnProperty("anchorRelativePosition")) {
            properties._anchorRelativePosition = 1;
            if (!(message.anchorRelativePosition && typeof message.anchorRelativePosition.length === "number" || $util.isString(message.anchorRelativePosition)))
                return "anchorRelativePosition: buffer expected";
        }
        if (message.focusRelativePosition != null && message.hasOwnProperty("focusRelativePosition")) {
            properties._focusRelativePosition = 1;
            if (!(message.focusRelativePosition && typeof message.focusRelativePosition.length === "number" || $util.isString(message.focusRelativePosition)))
                return "focusRelativePosition: buffer expected";
        }
        if (message.content != null && message.hasOwnProperty("content"))
            if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                return "content: buffer expected";
        if (message.data != null && message.hasOwnProperty("data")) {
            if (!$util.isObject(message.data))
                return "data: object expected";
            let key = Object.keys(message.data);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isString(message.data[key[i]]))
                    return "data: string{k:string} expected";
        }
        return null;
    };

    /**
     * Creates a ContentMarker message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ContentMarker
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ContentMarker} ContentMarker
     */
    ContentMarker.fromObject = function fromObject(object, long) {
        if (object instanceof $root.ContentMarker)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.ContentMarker();
        if (object.markerId != null)
            message.markerId = String(object.markerId);
        switch (object.type) {
        default:
            if (typeof object.type === "number") {
                message.type = object.type;
                break;
            }
            break;
        case "SUGGESTION":
        case 0:
            message.type = 0;
            break;
        }
        if (object.author != null)
            message.author = String(object.author);
        if (object.anchorRelativePosition != null)
            if (typeof object.anchorRelativePosition === "string")
                $util.base64.decode(object.anchorRelativePosition, message.anchorRelativePosition = $util.newBuffer($util.base64.length(object.anchorRelativePosition)), 0);
            else if (object.anchorRelativePosition.length >= 0)
                message.anchorRelativePosition = object.anchorRelativePosition;
        if (object.focusRelativePosition != null)
            if (typeof object.focusRelativePosition === "string")
                $util.base64.decode(object.focusRelativePosition, message.focusRelativePosition = $util.newBuffer($util.base64.length(object.focusRelativePosition)), 0);
            else if (object.focusRelativePosition.length >= 0)
                message.focusRelativePosition = object.focusRelativePosition;
        if (object.content != null)
            if (typeof object.content === "string")
                $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
            else if (object.content.length >= 0)
                message.content = object.content;
        if (object.data) {
            if (typeof object.data !== "object")
                throw TypeError(".ContentMarker.data: object expected");
            message.data = {};
            for (let keys = Object.keys(object.data), i = 0; i < keys.length; ++i) {
                if (keys[i] === "__proto__")
                    $util.makeProp(message.data, keys[i]);
                message.data[keys[i]] = String(object.data[keys[i]]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ContentMarker message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ContentMarker
     * @static
     * @param {ContentMarker} message ContentMarker
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ContentMarker.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.objects || options.defaults)
            object.data = {};
        if (options.defaults)
            if (options.bytes === String)
                object.content = "";
            else {
                object.content = [];
                if (options.bytes !== Array)
                    object.content = $util.newBuffer(object.content);
            }
        if (message.markerId != null && message.hasOwnProperty("markerId")) {
            object.markerId = message.markerId;
            if (options.oneofs)
                object._markerId = "markerId";
        }
        if (message.type != null && message.hasOwnProperty("type")) {
            object.type = options.enums === String ? $root.ContentMarkerType[message.type] === undefined ? message.type : $root.ContentMarkerType[message.type] : message.type;
            if (options.oneofs)
                object._type = "type";
        }
        if (message.author != null && message.hasOwnProperty("author")) {
            object.author = message.author;
            if (options.oneofs)
                object._author = "author";
        }
        if (message.anchorRelativePosition != null && message.hasOwnProperty("anchorRelativePosition")) {
            object.anchorRelativePosition = options.bytes === String ? $util.base64.encode(message.anchorRelativePosition, 0, message.anchorRelativePosition.length) : options.bytes === Array ? Array.prototype.slice.call(message.anchorRelativePosition) : message.anchorRelativePosition;
            if (options.oneofs)
                object._anchorRelativePosition = "anchorRelativePosition";
        }
        if (message.focusRelativePosition != null && message.hasOwnProperty("focusRelativePosition")) {
            object.focusRelativePosition = options.bytes === String ? $util.base64.encode(message.focusRelativePosition, 0, message.focusRelativePosition.length) : options.bytes === Array ? Array.prototype.slice.call(message.focusRelativePosition) : message.focusRelativePosition;
            if (options.oneofs)
                object._focusRelativePosition = "focusRelativePosition";
        }
        if (message.content != null && message.hasOwnProperty("content"))
            object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
        let keys2;
        if (message.data && (keys2 = Object.keys(message.data)).length) {
            object.data = {};
            for (let j = 0; j < keys2.length; ++j) {
                if (keys2[j] === "__proto__")
                    $util.makeProp(object.data, keys2[j]);
                object.data[keys2[j]] = message.data[keys2[j]];
            }
        }
        return object;
    };

    /**
     * Converts this ContentMarker to JSON.
     * @function toJSON
     * @memberof ContentMarker
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ContentMarker.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ContentMarker
     * @function getTypeUrl
     * @memberof ContentMarker
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ContentMarker.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ContentMarker";
    };

    return ContentMarker;
})();

export const ResourceIdentifier = $root.ResourceIdentifier = (() => {

    /**
     * Properties of a ResourceIdentifier.
     * @exports IResourceIdentifier
     * @interface IResourceIdentifier
     * @property {ResourceType|null} [type] ResourceIdentifier type
     * @property {string|null} [branchId] ResourceIdentifier branchId
     * @property {string|null} [id] ResourceIdentifier id
     */

    /**
     * Constructs a new ResourceIdentifier.
     * @exports ResourceIdentifier
     * @classdesc Identifier for a V2 socket connection, used by the single websocket.
     * @implements IResourceIdentifier
     * @constructor
     * @param {IResourceIdentifier=} [properties] Properties to set
     */
    function ResourceIdentifier(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ResourceIdentifier type.
     * @member {ResourceType|null|undefined} type
     * @memberof ResourceIdentifier
     * @instance
     */
    ResourceIdentifier.prototype.type = null;

    /**
     * ResourceIdentifier branchId.
     * @member {string|null|undefined} branchId
     * @memberof ResourceIdentifier
     * @instance
     */
    ResourceIdentifier.prototype.branchId = null;

    /**
     * ResourceIdentifier id.
     * @member {string|null|undefined} id
     * @memberof ResourceIdentifier
     * @instance
     */
    ResourceIdentifier.prototype.id = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ResourceIdentifier.prototype, "_type", {
        get: $util.oneOfGetter($oneOfFields = ["type"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ResourceIdentifier.prototype, "_branchId", {
        get: $util.oneOfGetter($oneOfFields = ["branchId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    Object.defineProperty(ResourceIdentifier.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new ResourceIdentifier instance using the specified properties.
     * @function create
     * @memberof ResourceIdentifier
     * @static
     * @param {IResourceIdentifier=} [properties] Properties to set
     * @returns {ResourceIdentifier} ResourceIdentifier instance
     */
    ResourceIdentifier.create = function create(properties) {
        return new ResourceIdentifier(properties);
    };

    /**
     * Encodes the specified ResourceIdentifier message. Does not implicitly {@link ResourceIdentifier.verify|verify} messages.
     * @function encode
     * @memberof ResourceIdentifier
     * @static
     * @param {IResourceIdentifier} message ResourceIdentifier message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ResourceIdentifier.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
        if (message.branchId != null && Object.hasOwnProperty.call(message, "branchId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.branchId);
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.id);
        return writer;
    };

    /**
     * Encodes the specified ResourceIdentifier message, length delimited. Does not implicitly {@link ResourceIdentifier.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ResourceIdentifier
     * @static
     * @param {IResourceIdentifier} message ResourceIdentifier message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ResourceIdentifier.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a ResourceIdentifier message from the specified reader or buffer.
     * @function decode
     * @memberof ResourceIdentifier
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ResourceIdentifier} ResourceIdentifier
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ResourceIdentifier.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResourceIdentifier();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.type = reader.int32();
                    break;
                }
            case 2: {
                    message.branchId = reader.string();
                    break;
                }
            case 3: {
                    message.id = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ResourceIdentifier message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ResourceIdentifier
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ResourceIdentifier} ResourceIdentifier
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ResourceIdentifier.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ResourceIdentifier message.
     * @function verify
     * @memberof ResourceIdentifier
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ResourceIdentifier.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.type != null && message.hasOwnProperty("type")) {
            properties._type = 1;
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        }
        if (message.branchId != null && message.hasOwnProperty("branchId")) {
            properties._branchId = 1;
            if (!$util.isString(message.branchId))
                return "branchId: string expected";
        }
        if (message.id != null && message.hasOwnProperty("id")) {
            properties._id = 1;
            if (!$util.isString(message.id))
                return "id: string expected";
        }
        return null;
    };

    /**
     * Creates a ResourceIdentifier message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ResourceIdentifier
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ResourceIdentifier} ResourceIdentifier
     */
    ResourceIdentifier.fromObject = function fromObject(object, long) {
        if (object instanceof $root.ResourceIdentifier)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.ResourceIdentifier();
        switch (object.type) {
        default:
            if (typeof object.type === "number") {
                message.type = object.type;
                break;
            }
            break;
        case "BRANCH":
        case 0:
            message.type = 0;
            break;
        case "PAGE":
        case 1:
            message.type = 1;
            break;
        case "REUSABLE_CONTENT":
        case 2:
            message.type = 2;
            break;
        }
        if (object.branchId != null)
            message.branchId = String(object.branchId);
        if (object.id != null)
            message.id = String(object.id);
        return message;
    };

    /**
     * Creates a plain object from a ResourceIdentifier message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ResourceIdentifier
     * @static
     * @param {ResourceIdentifier} message ResourceIdentifier
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ResourceIdentifier.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.type != null && message.hasOwnProperty("type")) {
            object.type = options.enums === String ? $root.ResourceType[message.type] === undefined ? message.type : $root.ResourceType[message.type] : message.type;
            if (options.oneofs)
                object._type = "type";
        }
        if (message.branchId != null && message.hasOwnProperty("branchId")) {
            object.branchId = message.branchId;
            if (options.oneofs)
                object._branchId = "branchId";
        }
        if (message.id != null && message.hasOwnProperty("id")) {
            object.id = message.id;
            if (options.oneofs)
                object._id = "id";
        }
        return object;
    };

    /**
     * Converts this ResourceIdentifier to JSON.
     * @function toJSON
     * @memberof ResourceIdentifier
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ResourceIdentifier.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ResourceIdentifier
     * @function getTypeUrl
     * @memberof ResourceIdentifier
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ResourceIdentifier.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ResourceIdentifier";
    };

    return ResourceIdentifier;
})();

/**
 * ContentOperationStatus enum.
 * @exports ContentOperationStatus
 * @enum {number}
 * @property {number} STARTING=0 STARTING value
 * @property {number} RUNNING=1 RUNNING value
 * @property {number} SUCCESS=2 SUCCESS value
 * @property {number} ERROR=3 ERROR value
 */
export const ContentOperationStatus = $root.ContentOperationStatus = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "STARTING"] = 0;
    values[valuesById[1] = "RUNNING"] = 1;
    values[valuesById[2] = "SUCCESS"] = 2;
    values[valuesById[3] = "ERROR"] = 3;
    return values;
})();

/**
 * UpdateFormatVersion enum.
 * @exports UpdateFormatVersion
 * @enum {number}
 * @property {number} UNSPECIFIED=0 UNSPECIFIED value
 * @property {number} V1=1 V1 value
 * @property {number} V2=2 V2 value
 */
export const UpdateFormatVersion = $root.UpdateFormatVersion = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNSPECIFIED"] = 0;
    values[valuesById[1] = "V1"] = 1;
    values[valuesById[2] = "V2"] = 2;
    return values;
})();

/**
 * ContentMarkerType enum.
 * @exports ContentMarkerType
 * @enum {number}
 * @property {number} SUGGESTION=0 SUGGESTION value
 */
export const ContentMarkerType = $root.ContentMarkerType = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "SUGGESTION"] = 0;
    return values;
})();

/**
 * ResourceType enum.
 * @exports ResourceType
 * @enum {number}
 * @property {number} BRANCH=0 BRANCH value
 * @property {number} PAGE=1 PAGE value
 * @property {number} REUSABLE_CONTENT=2 REUSABLE_CONTENT value
 */
export const ResourceType = $root.ResourceType = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BRANCH"] = 0;
    values[valuesById[1] = "PAGE"] = 1;
    values[valuesById[2] = "REUSABLE_CONTENT"] = 2;
    return values;
})();

export { $root as default };
